import React, { Component } from 'react';
import './homework-list.scss';
import { Modal, ModalBody, Tooltip, ModalFooter, Button } from "reactstrap";
import { Constants, ImageConstants, AccessRights } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import Filter from './filter/filter'
import CompletionReport from '../completion-report/completion-report'
import HomeworkEvalutionReport from '../reports/evaluation-report/evaluation-report'
import TestHomeworkEvalutionReport from '../../tests-v3/reports/test-results/test-results'
import StudentLevelReport from '../reports/student-level-report/student-level-report'
import HomeworkProgressionReport from '../reports/level-progression-report/level-progression-report'
import StudentDetailReport from '../reports/student-level-report/student-detail/student-detail'
import EloReport from '../reports/elo-report/elo-report'
import TestEloReport from '../../tests-v3/reports/elo-report/elo-report';
import HomeworkApi from '../../../apis/homework'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import WronglyAnswered from '../../common/wrong-answers-modal/wrong-answers-modalV1/wrong-answers-modal'
import ArchiveModal from '../../common/archive/archive'
import ReminderModel from '../reminder/reminder'
import EloDetail from './elo-detail/elo-detail'
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import Loading from '../../common/loading/loading'
import SessionCache from '../../routes/session-cache';
import NotificationModel from '../../tests-v3/test-list/notification/notification'
import SuccessComponent from '../../tests-v3/test-list/success/success'
import AllQuestions from '../../tests-v3/reports/all-questions/all-questions';
import moment from 'moment';
// import NewHomework from '../new-homework/new-homework'
import NewHomework from '../../clicker-flow-practice-v3/new-homework/new-homework';
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';
import QuestionList from './questions-list/questions-list';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import SchoolApi from '../../../apis/school';
import RecommandationReport from '../recommandation-report/recommandation-report';
import TestRecommandationReport from '../../tests-v3/reports/recommandation-report/recommandation-report';
import ActiveHomeworkModal from '../../common/active-homework/active-homework';
import ChapterEloAssessmentReport from './chapter-elo-assessment-report/chapter-elo-assessment-report';
import StudentPerformanceReport from '../../tests-v3/reports/student-performance-report/student-performance-report';
import TestQuestionList from '../../tests-v3/reports/questions-list/all-questions'

import Path from '../../routes/routes-path';
import { Link } from 'react-router-dom'
import ReactTooltip from 'react-tooltip';
import ClassPerformanceReport from '../../clicker-flow-practice-v3/clicker-flow-practice-list/class-performance-report/class-performance-report';
import ExamPrepReportInline from '../../clicker-assessment/test-list/exam-prep-report/exam-prep-report-inline';
import HomeworkForClickerPracticeApi from '../../../apis/homework-for-clicker-practice';
import ExcelJS from "exceljs";
import SchoolworkOverallClassPerformanceReport from '../../clicker-flow-practice-v3/clicker-flow-practice-list/schoolwork-class-performance-report/overall-class-performance-report';
import AssignmentDeletionComponent from '../../common/assignment-deletion-modal/archive';
let { Parser } = require('json2csv');



class HomeworkList extends Component {

    state = {
        homeworkList: [],
        topWrongPercentage: 0,
        contentIds: [],
        eloReport: [],
        copiedId: null,
        tabs: [
            { title: "Active", value: "ACTIVE" },
            { title: "Past Due Date", value: "PAST_DUE_DATE" },
            { title: "Archived", value: "ARCHIVED" }

        ],
        activeTabIndex: 0,
        selectedFilters: [
            // { type: "Class", value: "7th" }
        ],
        showBackButton: this.props.showBackButton ? this.props.showBackButton : false,
        isDraft: false,
        meta: { totalPages: 1, page: 1 },
        levels: [
            {
                type: "NOVICE",
                title: "Novice",
                subTitle: '<50%',
                students: [
                ]
            },
            {
                type: "PROFICIENT",
                title: "Proficient",
                subTitle: '50% - 80%',
                students: []
            },
            {
                type: "ADVANCE",
                title: "Advance",
                subTitle: '>80%',
                students: []
            }
        ]
    }
    caseStudy = 'CASE_STUDY';

    limit = 10
    filter = { status: "ACTIVE", }
    currentPage = 1;
    // pageLimit = 10

    accessRights = SessionCache.getAllowedModule()


    skillList = [
        {
            type: "KNOWLEDGE",
            title: "KNOWLEDGE - Ability to remember formulas",
            image: ImageConstants.KNOWLEDGE,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "CALCULATION",
            title: "CALCULATION - Ability to Calculate",
            image: ImageConstants.CALCULATION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "MODELING",
            title: "MODELING - Ability to get Logic & form equation",
            image: ImageConstants.MODELING,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "COMPREHENSION",
            title: "COMPREHENSION - Ability to Understand the Language",
            image: ImageConstants.COMPREHENSION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "CONCEPTUAL UNDERSTANDING",
            title: "CONCEPTUAL UNDERSTANDING",
            image: ImageConstants.COMPREHENSION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "ANALYTICAL REASONING & INTERPRETATION",
            title: "ANALYTICAL REASONING & INTERPRETATION",
            image: ImageConstants.COMPREHENSION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "VISUALIZATION & REPRESENTATION",
            title: "VISUALIZATION & REPRESENTATION",
            image: ImageConstants.COMPREHENSION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "MATHEMATICAL APPLICATION",
            title: "MATHEMATICAL APPLICATION",
            image: ImageConstants.COMPREHENSION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "APPLICATION TO PRACTICAL SKILLS",
            title: "APPLICATION TO PRACTICAL SKILLS",
            image: ImageConstants.COMPREHENSION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        }]

    orderedSkills = ["knowledge", "calculation", "modeling", "comprehension", 'conceptual understanding', 'analytical reasoning & interpretation',
        'visualization & representation', 'mathematical application', 'application to practical skills']

    constructor(props) {
        super(props)
        if (this.props.filter) {
            this.filter = {
                status: "ACTIVE",
                board: this.props.filter?.board || "",
                class: this.props.filter?.class || "",
                chapter: this.props.filter?.chapterKey || ""
            }

        }
    }

    orderedSkills = ["knowledge", "calculation", "modeling", "comprehension"]

    componentDidMount() {

        console.log(this.props)

        if (this.props.delegate?.props?.location?.state?.homeworkFilterPayload?.from === "LEARNING_RESOURCES") {

            this.setState({ showBackButton: true })
        } else {
            this.getHomeworkList(this.filter)
        }


        document.addEventListener('mousedown', this.handleClickEvent, false);

        if (this.props.delegate?.props?.location?.state?.homeworkAssignPayload?.from === "LEARNING_RESOURCES") {
            console.log('onclick-new-homework')
            this.onClickNewHomeWork()
        }

        if (this.props.delegate?.props?.location?.state?.homeworkAssignPayload?.from === "RECOMMANDATION_REPORT") {
            this.onClickNewHomeWork()
        }

        if (this.props.delegate?.props?.location?.state?.from === 'NEW_HOMEWORK_CREATION') {
            console.log(this.props.delegate?.props?.location?.state)
        }

        if (this.props.type != 'ADAPTIVE_CLASSWORK') {
            let tabs = this.state.tabs
            // tabs.push({ title: "Draft", value: "DRAFT" })
            tabs.push({ title: "Self Study", value: "SELF_STUDY" })
            this.setState({ tabs })
        }

    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }

    handleClickEvent = (event) => {
        if (this.studentRef && !this.studentRef.contains(event.target)) {
            this.setState({ userListIndex: -1 })
        }
    }


    getHomeworkList(payload = {}) {

        if (!payload.page) payload.page = 1
        if (!payload.limit) payload.limit = this.limit
        console.log(this.props.type)

        if (this.props.type === 'STANDARD_CLASSWORK') {
            payload.type = 'STANDARD,STANDARD_CLASSWORK'
        } else {
            payload.type = 'ADAPTIVE,ADAPTIVE_CLASSWORK'
        }

        if (payload.status === 'SELF_STUDY') {
            payload.type = 'MCQ,STR'
        }

        // payload.type = this.props.type
        this.currentPage = payload.page

        if (this.currentPage === 1) this.startIndex = 1

        this.setState({ isLoading: true, meta: {}, isDraft: false })
        HomeworkApi.getHomework(payload)
            .then(response => {
                console.log(response.response)
                this.buildHomeworkList(response.response)
                this.setState({ meta: response.meta, totalpages: response.meta.count, isLoading: false })
            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    buildHomeworkList(homeworks) {
        let homeworkGroup = {}, individualHomework = []
        let homeworkList = []
        for (let i = 0; i < homeworks.length; i++) {
            let homework = homeworks[i]
            let titles = ''

            if (homework?.chapter?.chapterList) {
                titles = homework?.chapter?.chapterList.map(ch => ch.title).join(', ');
            }
            let obj = {
                _id: homework._id,
                createdDateTimestamp: homework.countingwellCreatedTimestamp || homework.createdDate,
                createdDate: new Date(homework.countingwellCreatedTimestamp || homework.createdDate).toLocaleDateString("en-IN"),
                dueDate: new Date(homework.endDate).toLocaleDateString("en-IN"),
                chapter: homework?.chapter?.title ? homework?.chapter?.title : titles,
                chapterKey: homework?.chapter?.key ? homework?.chapter?.key : homework?.chapter?.chapterList,
                concepts: homework?.chapter?.concept,
                section: homework.section,
                sectionId: homework.sectionId,
                masterDataId: homework.masterDataId,
                class: homework.class,
                board: homework.board,
                completed: homework.completed,
                notCompleted: homework.notCompleted,
                inProgress: homework.inProgress,
                status: homework.status,
                conceptBuild: homework?.chapter?.conceptBuild,
                notificationCount: homework?.notificationCount || 0,
                lastNotificationSentDate: homework?.lastNotificationSentDate,
                approximateQuestions: homework?.approximateQuestions,
                approximateTime: homework?.approximateTime,
                category: homework?.category,
                users: homework?.users || [],
                basePath: homework.basePath,
                type: homework.type,
                cwPracticeNumber: homework.cwPracticeNumber ? homework.cwPracticeNumber : 0,
                practiceId: homework.practiceId ? homework.practiceId : '',
                schoolAssessmentId: homework.schoolAssessmentId,
                chapters: homework.chapters ? homework.chapters : '',
                selectedQuestionSetTitle: homework.selectedQuestionSetTitle || homework.questionSetTitle || homework.setName || ''
            }

            if (homework.class === 'Class 10' && homework.moreThanOneAssessment) {

                obj.moreThanOneAssessment = homework.moreThanOneAssessment
                obj.contentsHash = homework.contentsHash
            }

            if (homework.class === 'Class 10') {
                obj.assessmentQuestionType = homework.assessmentQuestionType
                obj.questionCategory = homework.questionCategory ? homework.questionCategory : 'M1'
                obj.contentsHash = homework.contentsHash
            }

            if (homework.assessmentQuestionType === 'SELECTED_ASSESSMENT_QUESTIONS') {
                obj.assessmentQuestionType = homework.assessmentQuestionType
                obj.contentsHash = homework.contentsHash
            }

            if (homework.practiceId) {
                obj.practiceId = homework.practiceId
            }


            if (homework.groupId) {
                if (homeworkGroup[homework.groupId]) {
                    homeworkGroup[homework.groupId].push(obj)
                } else {
                    homeworkGroup[homework.groupId] = [obj]
                }
            } else if (homework.type != this.caseStudy) {
                individualHomework.push(obj)
            }


            if (homework.type === this.caseStudy) {
                let test = homework
                let testObj = {
                    _id: test._id,
                    createdDate: new Date(test.countingwellCreatedTimestamp).toLocaleDateString("en-IN"),
                    dueDate: new Date(test.endDate).toLocaleDateString("en-IN"),
                    chapters: test?.chapters,
                    class: test.class,
                    section: test.section,
                    sectionId: test.sectionId,
                    time: test.duration,
                    questions: test.questionIds?.length,
                    completed: test.completed,
                    notCompleted: test.notCompleted,
                    createdDateTimestamp: test.countingwellCreatedTimestamp,
                    notificationCount: test.notificationCount,
                    lastNotificationSentDate: test.lastNotificationSentDate,
                    type: test.type,
                    users: test.users || [],
                    basePath: test.basePath,
                    status: test.status,
                    board: test.board,
                    questionSetId: test.questionIds?.length ? test.questionIds[0].questionSetId : ''
                }

                individualHomework.push(testObj)

            }
        }

        let groupedHomework = Object.values(homeworkGroup)

        homeworkList.push(...groupedHomework, ...individualHomework)

        this.setState({ homeworkList })

    }


    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                console.log(school)
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: school?.boards[0]?.name, showWarningPopup: true })
                }
                this.setState({ classDropdownItems: classes, })
            }).catch(err => {
            })
    }


    expand = (item, index) => {
        // let homeworkList = this.state.homeworkList
        // homeworkList[index].expand = !homeworkList[index].expand
        console.log(item)
        this.setState({ showMoreInfo: true, selectedHomeworkMore: item })
    }

    hideMoreInfoModal = () => {
        this.setState({ showMoreInfo: false })
    }

    onClickTab = (index) => {
        this.setState({ activeTabIndex: index, selectedItemIndex: null, selectedItemGroupIndex: null })
        let tab = this.state.tabs[index]
        this.filter.status = tab.value
        this.filter.page = 1
        this.getHomeworkList(this.filter)
    }

    hideReport = () => {
        this.setState({ showReport: false, selectedReportType: '' }, () => {
            this.scrollIntoViewForCurrentItem(this.state.selectedHomework._id)
        })
    }

    scrollIntoViewForCurrentItem(id) {
        if (id) {
            const element = document.getElementById(id);
            // console.log(id, element)
            if (element) {
                element.scrollIntoView({ behavior: "instant", block: 'center' })
            }

        }

    }

    onClickBack = () => {

        if (this.props.delegate?.props?.location?.state?.homeworkFilterPayload.from === "LEARNING_RESOURCES") {
            this.props.delegate.props.history.push({ pathname: Path.LEARNING_RESOURCES, state: { ...this.props.delegate.props.location.state.homeworkFilterPayload, from: 'NEW_HOMEWORK_CREATION' } })
        } else {
            this.props.back && this.props.back()
        }


    }

    onClickNewHomeWork = (item, index, isDraft) => {

        if (isDraft) {
            console.log(item)
            let concepts = item.concepts
            let conceptKeysList = [], eloIdsList = []
            concepts.forEach((concept, index) => {
                conceptKeysList.push({ value: concept.key, order: index + 1 })

                if (concept.elos && concept.elos.length) {
                    concept.elos.forEach(elo => {
                        eloIdsList.push({ value: elo.id, conceptValue: concept.key })
                    })
                }
            })
            item.conceptKeysList = conceptKeysList
            item.eloIdsList = eloIdsList
            // console.log(item)
            this.getClasses()
            this.setState({ showNewHomework: true, selectedHomework: item, selectedItemIndex: index, isDraft })
        } else {
            this.getClasses()
            this.setState({ showNewHomework: true })
        }

    }

    hideNewHomework = (value) => {

        console.log('hide homework Called')
        this.setState({ activeTabIndex: 0 })
        if (value) {
            this.filter = { status: "ACTIVE" }
            this.getHomeworkList(this.filter)
        }
        this.setState({ showNewHomework: false, showWarningPopup: false })
    }

    // showReport = (type, item, index, grpIndex) => {

    //     let pathname = `${type}${this.props.type}/${item._id}/${item.chapter}/${item.class}/${item.createdDateTimestamp}`

    //     this.setState({ showReport: false, selectedReportType: type, selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })

    //     let origin = window.location.origin

    //     window.open(origin + pathname)

    // }

    showReport = (type, item, index, grpIndex) => {

        console.log(item)

        // let pathname = `${type}${this.props.type}/${item._id}/${item.chapter}/${item.class}/${item.createdDateTimestamp}`

        this.setState({ showReport: true, selectedReportType: type, selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })

        // let origin = window.location.origin

        // window.open(origin + pathname)
    }



    downloadCompletionExcelReport(type, item, index, grpIndex) {

        this.setState({ selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })
        let payload = {}
        if (payload.page) payload.page = 1
        if (payload.page) payload.limit = this.limit
        // payload.type = this.props.match.params.type
        payload.type = type


        // if (this.props.match.params.homeworkId) {
        //     payload.homeworkId = this.props.match.params.homeworkId
        // }

        if (item && item._id) {
            payload.homeworkId = item._id
        }

        HomeworkApi.getHomeworkCompletionReport(payload)
            .then(response => {

                console.log("response", response)
                this.setState({
                    completedStudents: response.completedStudents,
                    inProgressStudents: response.inProgressStudents,
                    notCompletedStudents: response.notCompletedStudents, isLoading: false
                }, () => {
                    this.onClickCompletionReportExport()
                })

            }).catch(err => {
            })

    }


    // onClickCompletionReportExport = () => {

    //     if (this.state.exporting) return

    //     this.setState({ exporting: true })
    //     console.log("Export")


    //     if (this.state.completedStudents && this.state.completedStudents.length) {

    //         let homeworkCompletedStudentArray = this.state.completedStudents

    //         console.log(homeworkCompletedStudentArray)

    //         let csvBuild = []
    //         for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
    //             let item = homeworkCompletedStudentArray[i]

    //             let obj = {
    //             }
    //             if (item["name"]) {

    //                 if (item['name']) {
    //                     obj['Student Name'] = item['name']
    //                 }

    //                 // if (item['conceptName']) {
    //                 //     obj['Understood'] = "Understood"
    //                 // }

    //                 // if (item['conceptName']) {
    //                 //     obj['Not Understood'] = 'Not Understood'
    //                 // }

    //                 // if (item['conceptName']) {
    //                 //     obj['Not Attempted'] = 'Not Attempted'
    //                 // }
    //             }
    //             csvBuild.push(obj)

    //         }
    //         let json2csvParser = new Parser();
    //         let csv = json2csvParser.parse(csvBuild);

    //         console.log(csv);

    //         let hiddenElement = document.createElement('a');
    //         hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    //         hiddenElement.target = '_blank';
    //         hiddenElement.download = 'Completion_report_' + (new Date).toISOString() + '.csv';
    //         hiddenElement.click();

    //         this.setState({ exporting: false })

    //     } else {
    //         this.setState({ exporting: false })
    //     }
    // }

    onClickCompletionReportExport = async () => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Completion Report");

        // Header
        sheet.mergeCells("A1:C1");
        sheet.getCell("A1").value = "Completion Report";
        sheet.getCell("A1").font = { bold: true, size: 14 };
        sheet.getCell("A1").alignment = { horizontal: "center" };
        sheet.getCell("A1").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4AB7E7" }, // Blue background
        };


        // Table header
        const headerRow = sheet.addRow(["Completed", "Inprogress", "Not Completed"]);
        headerRow.font = { bold: true, size: 12 };
        // headerRow.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "FFB7D6F0" } // Light blue background
        // };
        // Apply background color + borders to header row
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFB7D6F0" } // Light blue (your screenshot color)
            };
        });

        // Find max length between both arrays
        const maxLength = Math.max(this.state.completedStudents.length, this.state.inProgressStudents.length, this.state.notCompletedStudents.length);

        // Fill rows with student names
        for (let i = 0; i < maxLength; i++) {
            sheet.addRow([
                (this.state.completedStudents[i] && this.state.completedStudents[i].name) || "", // Completed name if exists
                (this.state.inProgressStudents[i] && this.state.inProgressStudents[i].name) || "", // Not completed name if exists
                (this.state.notCompletedStudents[i] && this.state.notCompletedStudents[i].name) || ""
            ]);
        }

        // Generate Excel buffer
        const buffer = await workbook.xlsx.writeBuffer();

        // Trigger download
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download =
            `completion_report_${this.state.selectedHomework.chapter.split(' ').join('_')}_` + new Date().toISOString() + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    }

    downloadEvaluationExcelReport(type, item, index, grpIndex) {
        this.setState({ selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })
        let payload = {}
        if (item && item._id) {
            payload.homeworkId = item._id
        }

        this.setState({ isLoading: true })

        HomeworkApi.getHomeworkEvaluationReport(payload)
            .then(response => {


                let levels = this.state.levels
                let noviceStudents = response?.noviceStudents || []
                let proficientStudents = response?.proficientStudents || []
                let advancedStudents = response?.advancedStudents || []

                levels[0].students = noviceStudents
                levels[1].students = proficientStudents
                levels[2].students = advancedStudents

                this.setState(
                    {
                        noviceStudents: response.noviceStudents,
                        proficientStudents: response.proficientStudents,
                        advancedStudents: response.advancedStudents,
                        notCompletedStudents: response.notCompletedStudents,
                        isLoading: false,
                        levels
                    }, () => {
                        this.onClickEvaluationReportExport()
                    })

            }).catch(err => {
            })
    }

    onClickEvaluationReportExport() {

        if (this.state.exporting) return

        this.setState({ exporting: true })
        console.log("Export")


        if (this.state.levels && this.state.levels.length) {

            let homeworkCompletedStudentArray = this.state.levels

            console.log(homeworkCompletedStudentArray)

            let csvBuild = []

            // let reportTitle = {'Title' : "Learning Gap Report"}

            // csvBuild.push(reportTitle)

            for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
                let item = homeworkCompletedStudentArray[i]

                let obj = {
                }
                if (item["type"]) {

                    if (item['type']) {
                        obj['Type'] = item['type']
                    }

                    // if (item['conceptName']) {
                    //     obj['Understood'] = "Understood"
                    // }

                    // if (item['conceptName']) {
                    //     obj['Not Understood'] = 'Not Understood'
                    // }

                    // if (item['conceptName']) {
                    //     obj['Not Attempted'] = 'Not Attempted'
                    // }

                    csvBuild.push(obj)


                    console.log(item.students)
                    let studentObject = {}
                    if (item.students && item.students.length > 0) {
                        for (let j = 0; j < item.students.length; j++) {
                            console.log(item.students[j])
                            let student = item.students[j]
                            studentObject[`Type`] = student.name
                            studentObject[`Mark Scored`] = student.marks
                            studentObject[`Total Marks`] = student.totalMark
                            csvBuild.push(studentObject)
                            studentObject = {}
                        }
                    } else {
                        studentObject['Type'] = 'No Students in this Type'
                        csvBuild.push(studentObject)
                        studentObject = {}
                    }




                }


            }
            let json2csvParser = new Parser();
            let csv = json2csvParser.parse(csvBuild);

            console.log(csv);

            let hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'Assessment_Result_Report' + (new Date).toISOString() + '.csv';
            hiddenElement.click();

            this.setState({ exporting: false })

        } else {
            this.setState({ exporting: false })
        }


    }

    downloadLearningGapExcelReport(type, item, index, grpIndex) {
        this.setState({ selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })
        let payload = {}
        if (item && item._id) {
            payload.homeworkId = item._id
        }

        this.setState({ isLoading: true })

        HomeworkApi.getEloReport(payload)
            .then(response => {

                let skillBaseReport = response.skillBaseReport || {}
                let localSkillList = this.skillList
                let result = []
                for (let i = 0; i < localSkillList.length; i++) {
                    let skill = localSkillList[i]
                    let detail = skillBaseReport[skill.type.toLowerCase()]
                    if (!detail) continue
                    skill.mastered = detail.correct || 0
                    skill.correctUsers = detail.correctUsers || []
                    skill.incorrectUsers = detail.incorrectUsers || []
                    skill.needImprovement = detail.incorrect
                    let total = detail.correct + detail.incorrect
                    skill.masteredPercentage = this.calculatePercentage(detail.correct, total)
                    skill.needImprovementPercentage = 100 - skill.masteredPercentage
                    result.push(skill)
                }

                this.setState({ skillWiseReport: result, eloReport: response.conceptBaseReport, totalUsers: response.totalUsers, isLoading: false }, () => {
                    this.onClickExportLearningGapExcelReport(item, result)
                })

            }).catch(err => {

                this.setState({ isLoading: false })
            })
    }


    // onClickExportLearningGapExcelReport = () => {

    //     if (this.state.exporting) return

    //     this.setState({ exporting: true })
    //     console.log("Export")

    //     let eloList = this.state.eloReport

    //     if (eloList && eloList.length > 0) {

    //         let homeworkCompletedStudentArray = eloList

    //         console.log(homeworkCompletedStudentArray)

    //         let csvBuild = []
    //         for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
    //             let item = homeworkCompletedStudentArray[i]

    //             let obj = {
    //             }
    //             if (item["conceptName"]) {

    //                 if (item['conceptName']) {
    //                     obj['Concept Name'] = item['conceptName']
    //                 }

    //                 // if (item['conceptName']) {
    //                 //     obj['Understood'] = "Understood"
    //                 // }

    //                 // if (item['conceptName']) {
    //                 //     obj['Not Understood'] = 'Not Understood'
    //                 // }

    //                 // if (item['conceptName']) {
    //                 //     obj['Not Attempted'] = 'Not Attempted'
    //                 // }

    //                 csvBuild.push(obj)

    //                 let eloObject = {}

    //                 let elo = item
    //                 if (elo.skill == "modelling") elo.skill = "modeling"
    //                 let skills = elo.skill
    //                 for (let index = 0; index < this.orderedSkills.length; index++) {
    //                     let key = this.orderedSkills[index]
    //                     let skillDetails = skills[key]

    //                     if (!skillDetails) continue

    //                     if (skillDetails && skillDetails.length) {
    //                         // arr.push(
    //                         //     <tr className="mt-4">
    //                         //         <td className="skill-title pl-5" colSpan="4">
    //                         //             <span>
    //                         //                 <img className="skill-img" src={getImageSource(ImageConstants[key.toUpperCase()])} /><b className="pl-4">{key.toUpperCase()}</b>
    //                         //             </span>
    //                         //         </td>
    //                         //     </tr>
    //                         // )


    //                         for (let i = 0; i < skillDetails.length; i++) {
    //                             let item = skillDetails[i]
    //                             let notAttempted = this.state.totalUsers - ((item.incorrect || 0) + (item.correct || 0))
    //                             eloObject['Concept Name'] = item.title
    //                             eloObject['Understood'] = item.correct
    //                             eloObject['Not Understood'] = item.incorrect
    //                             eloObject['Not Attempted'] = notAttempted
    //                             csvBuild.push(eloObject)
    //                             eloObject = {}
    //                         }
    //                     }

    //                 }




    //             }


    //         }
    //         let json2csvParser = new Parser();
    //         let csv = json2csvParser.parse(csvBuild);

    //         console.log(csv);

    //         let hiddenElement = document.createElement('a');
    //         hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    //         hiddenElement.target = '_blank';
    //         hiddenElement.download = 'learning_gap_report_' + (new Date).toISOString() + '.csv';
    //         hiddenElement.click();

    //         this.setState({ exporting: false })

    //     } else {
    //         this.setState({ exporting: false })
    //     }




    // }


    onClickExportLearningGapExcelReport = async (selectedItem, skillBaseReport) => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Learning Gap Report");

        // Header
        sheet.mergeCells("A1:D1");
        sheet.getCell("A1").value = "By Skills";
        sheet.getCell("A1").font = { bold: true, size: 14 };
        sheet.getCell("A1").alignment = { horizontal: "center" };
        sheet.getCell("A1").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4AB7E7" }, // Blue background
        };


        // Table header
        const headerRowOne = sheet.addRow(["Skills", "Mastered", "Need Improvements"]);
        headerRowOne.font = { bold: true, size: 12 };
        headerRowOne.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFB7D6F0" } // Light blue (your screenshot color)
            };
        });

        for (let i = 0; i < skillBaseReport.length; i++) {
            let item = skillBaseReport[i]
            sheet.addRow([item.title, item.mastered, item.needImprovement]);
        }


        sheet.addRow([])
        sheet.addRow([])
        // Header
        sheet.mergeCells("A8:D8");
        sheet.getCell("A8").value = "By Learning Outcomes";
        sheet.getCell("A8").font = { bold: true, size: 14 };
        sheet.getCell("A8").alignment = { horizontal: "center" };
        sheet.getCell("A8").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4AB7E7" }, // Blue background
        };



        // Table header
        const headerRow = sheet.addRow(["Concept Name", "Understood", "Not Understood", "Not Attempted"]);
        headerRow.font = { bold: true, size: 12 };
        // headerRow.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "FFB7D6F0" } // Light blue background
        // };
        // Apply background color + borders to header row
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFB7D6F0" } // Light blue (your screenshot color)
            };
        });
        // Loop through students array and add rows


        if (this.state.exporting) return

        this.setState({ exporting: true })
        console.log("Export")

        let eloList = this.state.eloReport

        if (eloList && eloList.length > 0) {

            let homeworkCompletedStudentArray = eloList

            // console.log(homeworkCompletedStudentArray)

            let csvBuild = []
            for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
                let item = homeworkCompletedStudentArray[i]

                let obj = {
                }
                if (item["conceptName"]) {

                    sheet.addRow([item["conceptName"]]);

                    let elo = item
                    if (elo.skill == "modelling") elo.skill = "modeling"
                    let skills = elo.skill
                    for (let index = 0; index < this.orderedSkills.length; index++) {
                        let key = this.orderedSkills[index]
                        let skillDetails = skills[key]

                        if (!skillDetails) continue

                        if (skillDetails && skillDetails.length) {
                            // arr.push(
                            //     <tr className="mt-4">
                            //         <td className="skill-title pl-5" colSpan="4">
                            //             <span>
                            //                 <img className="skill-img" src={getImageSource(ImageConstants[key.toUpperCase()])} /><b className="pl-4">{key.toUpperCase()}</b>
                            //             </span>
                            //         </td>
                            //     </tr>
                            // )


                            for (let i = 0; i < skillDetails.length; i++) {
                                let item = skillDetails[i]
                                let notAttempted = this.state.totalUsers - ((item.incorrect || 0) + (item.correct || 0))
                                sheet.addRow([item.title, item.correct, item.incorrect, notAttempted]);
                            }
                        }

                    }
                }
            }



        }



        // Generate Excel buffer
        const buffer = await workbook.xlsx.writeBuffer();

        // Trigger download
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download =
            `learning_gap_report_${selectedItem.chapter.split(' ').join('_')}_` + new Date().toISOString() + ".xlsx";
        document.body.appendChild(link);
        link.click();
        this.setState({ exporting: false })
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };




    getTabs = () => {
        return (<div>
            {this.state.tabs.map((tab, index) => (
                <div key={'tab' + index} className={`tab mr-3 ${this.state.activeTabIndex == index ? 'tab-active' : ''}`} onClick={() => this.onClickTab(index)}>
                    <div className='tab-center'>
                        <span>{tab.title}</span>
                    </div>

                    {this.state.activeTabIndex == index ? <div className='active-cirlce'>
                    </div> : ""}
                </div>
            ))}
        </div>)
    }

    handleDateEvent = (event, picker, item, index) => {
        this.dueDate = picker.startDate ? (new Date(new Date(picker.startDate).setHours(23, 59, 59, 999)).toISOString()) : ''

        let payload = { homeworkId: item._id, dueDate: this.dueDate, }
        HomeworkApi.updateHomework(payload)
            .then(response => {
                this.getHomeworkList(this.filter)
            }).catch(err => {
            })
    }

    hideWrongAnswersReport = () => {
        this.setState({ showWrongAnswersReport: false })
    }

    hideStudentLevelReport = () => {
        this.setState({ showStudentLevelReport: false })
    }

    hideReminderModal = () => {
        this.setState({ showReminderModal: false })
    }

    onOkArchiveModal = () => {
        this.setState({ showArchiveModal: false })
    }

    onCloseArchiveModal = () => {
        this.setState({ showArchiveModal: false })
    }

    onOkActiveModal = () => {
        this.setState({ showActiveConfirmationModal: false })
    }

    onCloseActiveModal = () => {
        this.setState({ showActiveConfirmationModal: false })
    }

    onCLickNotitification(item, type) {
        this.setState({ notificationType: type, selectedItem: item, showNotification: true })
    }

    hideNotification = () => {
        this.setState({ showNotification: false })
    }

    onSentNotification = () => {
        this.hideNotification()
        this.showToaster('info', "Message shared successfully")
    }

    hideNewHomework = () => {
        this.setState({
            showNewHomework: false, showBackButton: false
        })
    }

    onClickDownloadExamPrepReport = (item) => {
        let payload = {
            board: item.board,
            class: item.class,
            section: item.section,
            assessmentId: typeof item._id === 'object'
                ? (item._id.$oid || item._id.toString())
                : (item._id || item.schoolAssessmentId || item.homeworkId || item.id || ''),
            format: 'excel'
        };
        SchoolApi.getExamPrepReport(payload)
            .then(res => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'exam-prep-report.xlsx';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }).catch(err => {
                console.log(err);
                alert("Error downloading report.");
            });
    }

    onClickShowExamPrepReport = (item) => {
        this.setState({ showExamPrepReport: true, selectedItem: item });
    }

    hideExamPrepReport = () => {
        this.setState({ showExamPrepReport: false });
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 5000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }


    renderReminderModal = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideReminderModal} size={'lg'}>
                <ModalBody >
                    <ReminderModel message={this.state.reminderMessage} notCompleted={this.state.notCompleted} homeworkId={this.state.reminderHomeworkId} notificationCount={this.state.notificationCount} notificationDate={this.state.notificationDate} back={this.hideReminderModal} />
                </ModalBody>
            </Modal>
        )
    }

    renderNotificationIcons(item) {
        return (
            <div className="notification-icons">
                <span className="pt-2 mr-2">
                    <img alt="" className="icon-20 cursor-pointer" src={getImageSource(ImageConstants.EMAIL)} onClick={() => this.onCLickNotitification(item, "EMAIL")} />
                </span>
                <span className="pt-2">
                    <img alt="" className="icon-20 cursor-pointer" src={getImageSource(ImageConstants.WHATSAPP)} onClick={() => this.onCLickNotitification(item, "WHATSAPP")} />
                </span>
            </div>
        )
    }

    onChangeType = (type) => {
        this.setState({ notificationType: type })
    }

    showSuccessModal = (item) => {
        // console.log(item)
        let selectedSection = {}
        item.sectionId.forEach(sectionId =>
            selectedSection[sectionId] = item.section[sectionId]
        )

        item.section = selectedSection
        this.setState({ showSuccess: true, selectedItem: item })
    }

    onInviteMoreStudent = () => {
        this.setState({ showSuccess: false, notificationType: "WHATSAPP", showNotification: true })
    }

    closeSuccess = () => {
        this.setState({ showSuccess: false })
    }

    renderNotificationModal = () => {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideNotification} size={'lg'}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img alt="" className="close-icon cursor-pointer" onClick={this.hideNotification} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>

                    <div className="header-text text-center pt-4">
                        <span>SHARE THE INVITE WITH STUDENTS</span>
                    </div>
                    <NotificationModel type={this.state.notificationType} from="HOMEWORK" assessment={this.state.selectedItem} onChangeType={this.onChangeType} onOk={this.onSentNotification} />
                </ModalBody>
            </Modal>
        )
    }

    handleCopy = (id) => {
        navigator.clipboard.writeText(id)
            .then(() => {
                // console.log("Copied:", id);
                this.setState({ copiedId: id });
                ReactTooltip.hide();

                setTimeout(() => {
                    this.setState({ copiedId: null });
                }, 2000);
            })
            .catch(err => console.error("Copy failed:", err));
    };


    getHomeworkCard = (item, index, groupIndex) => {

        return (
            <div className='homework-card' onMouseEnter={ReactTooltip.rebuild} >
                <div className='row m-0'>
                    <div className={`col border-bottom  ${this.state.activeTabIndex === 0 || this.state.activeTabIndex === 3 ? 'border-right' : ""}`} style={{ textAlign: `${this.state.activeTabIndex === 0 ? "" : 'start'}` }}>
                        <span className='header-label'>Created: <strong>{item.createdDate}</strong></span>
                    </div>
                    {
                        this.state.activeTabIndex != 3 ?
                            <>

                                {
                                    item.type != 'MCQ' && item.type != 'STR' ?
                                        <div className={`col border-bottom ${item.cwPracticeNumber ? 'border-right' : ''} `}>
                                            <span className='header-label'>Due: <strong className="pr-2">{item.dueDate}</strong>
                                                {
                                                    this.state.activeTabIndex === 0 ?
                                                        <> {
                                                            this.checkEditCondtion() ?
                                                                <DateRangePicker onApply={(event, picker) => this.handleDateEvent(event, picker, item, index, groupIndex)}
                                                                    initialSettings={{ singleDatePicker: true, minDate: this.startDate ? this.startDate : new Date() }}
                                                                >
                                                                    <img className="edit-icon" src={getImageSource(ImageConstants.EDIT)} />
                                                                </DateRangePicker>
                                                                : ""
                                                        }</>
                                                        :
                                                        <></>
                                                }
                                            </span>
                                        </div>
                                        :
                                        <div className={`col border-bottom ${item.cwPracticeNumber ? 'border-right' : ''} `}>
                                            <span className='header-label'><strong className="pr-2">{item.type === 'MCQ' ? 'Multiple Choice Questions' : item.type === 'STR' ? 'Structured Response Questions' : ''}</strong>
                                            </span>
                                        </div>
                                }



                                {
                                    item.cwPracticeNumber ? <div className='col border-bottom'>
                                        <span className='header-label'><strong className="pr-2">CW {item.cwPracticeNumber}</strong>
                                        </span>
                                    </div>
                                        :
                                        <></>
                                }

                            </>
                            :
                            <>
                                <div className='col border-bottom'>
                                    {/* <span className='header-label'><strong className="pr-2">CW {item.cwPracticeNumber}</strong> */}
                                    {/* {
                                            this.checkEditCondtion() ?
                                                <DateRangePicker onApply={(event, picker) => this.handleDateEvent(event, picker, item, index, groupIndex)}
                                                    initialSettings={{ singleDatePicker: true, minDate: this.startDate ? this.startDate : new Date() }}
                                                >
                                                    <img className="edit-icon" src={getImageSource(ImageConstants.EDIT)} />
                                                </DateRangePicker>
                                                : ""
                                        } */}
                                    {/* </span> */}
                                </div>
                            </>
                    }

                </div>

                <div className='p-3'>
                    <div className='row'>
                        <div className='col'>
                            <div className='body-title'>Chapter</div>
                            <div className='body-sub-title pt-2'><strong>{item.chapter}</strong></div>
                        </div>
                        <div className='col'>
                            <div className='row'>
                                <div>
                                    <div>Qs: <strong>{item.approximateQuestions}</strong></div>
                                </div>
                                <div className='ml-2'>
                                    <div>Time: <strong>{item.approximateTime}m</strong></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row pt-3'>
                        <div className='col'>
                            <div className='body-title'>Concepts</div>
                            {item.concepts?.map(concept => (
                                <div className='body-sub-title pt-2'><strong>{concept && concept.title ? concept.title : ""}</strong></div>
                            ))}
                        </div>
                    </div>

                    {
                        item.expand ? <div className='pt-3'>
                            <div className='body-title'>Learning Outcome</div>

                            {item.elos.map(elo => (
                                <div className='body-sub-title pt-2'><strong>{elo.title}</strong></div>
                            ))}
                        </div> : ''}

                    <div className='pt-3 row more-color'>
                        <div className='col my-auto'><span className='cursor-pointer' onClick={() => this.expand(item, index)}>{item.expand ? 'Less' : 'More >>'}</span></div>
                        {
                            item.type != 'MCQ' && item.type != 'STR' ?
                                <div className='col'>
                                    {
                                        item?.status != "ARCHIVED" ?
                                            this.state.activeTabIndex != 3 ? this.getActions(item, index, groupIndex) : <></>
                                            :
                                            this.getActivateHomework(item)
                                    }
                                </div>
                                :
                                <></>
                        }

                    </div>
                </div>

                {
                    item.schoolAssessmentId ?
                        <div className='school-assessmentid-text-wrapper position-relative'>
                            <span className='school-assessmentid-text cursor-pointer'
                                data-tip={"Copy"}
                                onClick={() => this.handleCopy(item.schoolAssessmentId)}>{item.schoolAssessmentId}</span>
                            <img className='copy-icon-size'
                                data-tip={"Copy"}
                                onClick={() => this.handleCopy(item.schoolAssessmentId)}
                                src={getImageSource(ImageConstants.COPY_ICON)} />
                            {this.state.copiedId === item.schoolAssessmentId && (
                                <div className="copied-tooltip">
                                    Copied!
                                </div>
                            )}
                        </div>
                        :
                        <></>
                }


            </div>
        )

    }

    renderStatus = (item, index, grpIndex) => {
        return (<div>
            <div className='completed'>
                <div className='completed-text'>
                    <div className='cursor-pointer' onClick={() => { this.showReport('COMPLETION_REPORT', item, index, grpIndex) }} >
                        <span>
                            <img className="status-image" src={getImageSource(ImageConstants.CORRECT)} />
                        </span>
                        <span className="float-right">
                            {item.completed && item.completed.length ? item.completed.length : 0}
                        </span>
                    </div>
                </div>
            </div>

            <div className='in-progress mt-3'>
                <div className='in-progress-text'>
                    <div className='cursor-pointer' onClick={() => { this.showReport('COMPLETION_REPORT', item, index, grpIndex) }} >
                        <span>
                            <img className="status-image" src={getImageSource(ImageConstants.IN_PROGRESS_ICON)} />
                        </span>
                        <span className="float-right">
                            {item.inProgress && item.inProgress.length ? item.inProgress.length : 0}
                        </span>
                    </div>
                </div>
            </div>

            <div className='not-completed mt-3'>
                <div className='not-completed-text'>
                    <div className='cursor-pointer' onClick={() => { this.showReport('COMPLETION_REPORT', item, index, grpIndex) }}>
                        <span>
                            <img className="status-image" src={getImageSource(ImageConstants.WRONG)} /></span>
                        <span className="float-right">
                            {item.notCompleted && item.notCompleted.length ? item.notCompleted.length : 0}
                        </span>
                    </div>
                </div>
            </div>
        </div>)
    }

    onCLickStudentLevelReport(item) {
        this.setState({ showStudentLevelReport: true, selectedHomework: item })
    }


    onClickDownloadPdf = (type, item, index) => {

        this.setState({ selectedReportType: type, selectedItem: item, selectedIndex: index, isPdfLoading: true })

        if (type === 'MOST_WRONG_REPORT') {
            this.getHomeworkWrongAnswer(item, type)
        }

        if (type === "RECOMMANDATION_REPORT") {
            this.getHomeworkWrongAnswer(item, type)
        }

        if (type === 'CLASS_PERFORMANCE_REPORT') {
            this.getClassPerformanceReport(item, type)
        }

        if (type === 'SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT') {
            this.getSchoolworkOverallClassPerformanceReport(item, type)
        }


    }

    getSchoolworkOverallClassPerformanceReport(selectedItem) {

        let payload = {
            homeworkId: selectedItem._id,
            classText: selectedItem.class,
            board: selectedItem.board,
            type: selectedItem.type,
            sectionId: selectedItem.sectionId,
            masterDataId: selectedItem.masterDataId,
            duration: selectedItem.approximateTime,
            chapterKey: selectedItem.chapterKey,
            chapterTitle: selectedItem.chapter
        }

        // this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getSchoolworkOverallClassPerformanceReport(payload).then(res => {
            // console.log(res)
            this.setState({ isPdfLoading: false })

            this.downloadPDF(res.link, "Class_Performance_Report")

        }).catch(err => {
            console.log(err)
        })
    }

    getClassPerformanceReport(selectedItem) {

        let payload = {
            homeworkId: selectedItem._id,
            classText: selectedItem.class,
            board: selectedItem.board,
            type: selectedItem.type,
            sectionId: selectedItem.sectionId,
            masterDataId: selectedItem.masterDataId,
            duration: selectedItem.approximateTime,
            chapterKey: selectedItem.chapterKey
        }

        // this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getClassPerformanceReport(payload).then(res => {
            console.log(res)
            // this.setState({ ...res, isLoading: false })
            this.setState({ isPdfLoading: false })
            this.downloadPDF(res.link, 'Students_Performance')

        }).catch(err => {
            console.log(err)
        })
    }

    getEloReport(selectedItem, type) {
        let payload = {}
        if (selectedItem) {
            payload.homeworkId = selectedItem._id
        }


        payload.type = 'CLICKER_PRACTICE_STANDARD'


        // this.setState({ isLoading: true })

        HomeworkApi.getEloReport(payload)
            .then(response => {

                console.log(response)

                let skillBaseReport = response.skillBaseReport || {}
                let localSkillList = this.skillList
                let result = []
                // for (let i = 0; i < localSkillList.length; i++) {
                //     let skill = localSkillList[i]
                //     let detail = skillBaseReport[skill.type.toLowerCase()]
                //     if (!detail) continue
                //     skill.mastered = detail.correct || 0
                //     skill.correctUsers = detail.correctUsers || []
                //     skill.incorrectUsers = detail.incorrectUsers || []
                //     skill.needImprovement = detail.incorrect
                //     let total = detail.correct + detail.incorrect
                //     skill.masteredPercentage = this.calculatePercentage(detail.correct, total)
                //     skill.needImprovementPercentage = 100 - skill.masteredPercentage
                //     result.push(skill)
                // }

                let conceptWiseReport = response.conceptBaseReport

                let conceptWiseTopFiveNotClearedElo = []

                for (let i = 0; i < conceptWiseReport.length; i++) {
                    let concept = conceptWiseReport[i]
                    let allSkills = {}
                    let eloLimit = 0

                    for (let j = 0; j < localSkillList.length; j++) {
                        let skill = localSkillList[j]
                        let detail = concept.skill[skill.type.toLowerCase()]
                        if (!detail) continue

                        let notClearedEloList = []

                        for (let k = 0; k < detail.length; k++) {
                            let elo = detail[k]
                            if (elo.incorrect) {
                                if (eloLimit === 5) continue
                                eloLimit += 1
                                notClearedEloList.push(elo)
                            }
                        }

                        if (!allSkills[skill.type.toLowerCase()]) {
                            allSkills[skill.type.toLowerCase()] = [...notClearedEloList]
                        } else {
                            allSkills[skill.type.toLowerCase()].push(notClearedEloList)
                        }

                    }
                    conceptWiseTopFiveNotClearedElo.push({ conceptName: concept.conceptName, skill: allSkills })

                }


                this.setState({
                    skillWiseReport: result,
                    eloReport: response.topFiveNotClearedEloAcrossConcept,
                    totalUsers: response.totalUsers, isLoading: false
                }, () => {
                    // console.log('callback called')
                    setTimeout(() => {
                        this.generatePdf(response.topFiveNotClearedEloAcrossConcept, selectedItem)
                    }, 1000)

                })

            }).catch(err => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    calculatePercentage(scored = 0, total = 0) {

        if (scored == 0 || total == 0) return 0

        return Math.round((scored / total) * 100)
    }


    generatePdf(conceptWiseTopFiveNotClearedElo, selectedItem) {
        console.log(conceptWiseTopFiveNotClearedElo)


        let notClearedEloIds = [], eloNotClearedStudentPercentageHashByEloId = {}

        conceptWiseTopFiveNotClearedElo.forEach(elo => {
            // if (elo.skill == "modelling") elo.skill = "modeling"
            // let skills = elo.skill
            // for (let index = 0; index < this.orderedSkills.length; index++) {
            //     let key = this.orderedSkills[index]
            //     let skillDetails = skills[key]

            //     if (!skillDetails) continue

            //     if (skillDetails && skillDetails.length) {

            //         skillDetails.map(item => {
            notClearedEloIds.push(elo.eloId)
            eloNotClearedStudentPercentageHashByEloId[elo.eloId] = `${this.calculatePercentage(elo.incorrect, this.state.totalUsers) || 0}%`
            //         })

            //     }

            // }
        })

        //console.log(!this.state.contentIds, !notClearedEloIds.length, !this.state.contentIds.length)


        let conceptNames = []
        selectedItem.concepts.forEach(concept => conceptNames.push(concept.title))

        if (!this.state.contentIds.length && !notClearedEloIds.length) {
            console.log('return')
            return;
        }

        let payload = {
            contentIds: this.state.contentIds,
            class: selectedItem.class,
            section: selectedItem.section ? selectedItem.section : "",
            chapterTitle: selectedItem.chapter,
            conceptNames: conceptNames,
            notClearedEloIds,
            topWrongPercentage: this.state.topWrongPercentage,
            eloNotClearedStudentPercentageHashByEloId
        }

        // console.log(payload)

        SchoolApi.generatePdf(payload).then(response => {
            // console.log(response)
            this.setState({ isPdfLoading: false })
            this.downloadPDF(response.data.webLink, "Remedial_Report")
        }).catch(err => {
            console.log(err)
        })

    }

    getHomeworkWrongAnswer(selectedItem, selectedReportType) {
        let payload = {}
        if (selectedItem) {
            payload.homeworkId = selectedItem._id
            payload.type = selectedItem.type
            payload.chapterTitle = selectedItem.chapter
            payload.isPdfGeneration = true
        }

        HomeworkApi.getHomeworkWrongAnswersReport(payload)
            .then(response => {

                let wrongAnswersHash = {}
                let result = response.result.sort((x, y) => (x.percentage > y.percentage ? -1 : 1))

                console.log(result)
                //let filterQuestions = []

                let questionsArray1 = [], users1 = [], questionsArray2 = [], users2 = [],
                    questionsArray3 = [], users3 = [], questionsArray4 = [], users4 = []

                for (let i = 0; i < result.length; i++) {

                    let data = result[i]

                    if (data.percentage < 25) {

                        result[i].filterPercentage = 25
                        result[i].filterRangeText = "Less than 25%"

                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray1.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users1.push(...result[i].users)

                        if (users1.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users1.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }

                            });
                        }
                        result[i].allQuestionsArray = questionsArray1
                        result[i].allUsers = uniqueAllUsers
                        result[i].questionCount = questionsArray1.length

                    } else if (data.percentage >= 25 && data.percentage <= 50) {

                        result[i].filterPercentage = 50
                        result[i].filterRangeText = "25 - 50%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray2.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users2.push(...result[i].users)

                        if (users2.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users2.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray2
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 50 && data.percentage <= 75) {

                        result[i].filterPercentage = 75
                        result[i].filterRangeText = "51 - 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray3.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users3.push(...result[i].users)

                        if (users3.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users3.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray3
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 75) {

                        result[i].filterPercentage = 100
                        result[i].filterRangeText = "Greater than 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray4.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users4.push(...result[i].users)

                        if (users4.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users4.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray4
                        result[i].allUsers = uniqueAllUsers
                    } else {
                        result = []
                    }

                    console.log(result[i])
                    if (!wrongAnswersHash[`${result[i].filterPercentage}`]) {
                        wrongAnswersHash[`${result[i].filterPercentage}`] = [result[i]]
                    }



                }



                const uniqueIds = [];

                const unique = result.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.filterPercentage);

                    if (!isDuplicate) {
                        uniqueIds.push(element.filterPercentage);

                        return true;
                    }
                    return false;
                });


                // console.log('wrong hash', wrongAnswersHash)
                // console.log('unique', unique)



                //console.log('wrong answer percentage', wrongAnswersHash)

                let filterHash = {}
                Object.keys(wrongAnswersHash).forEach(ele => {
                    filterHash[ele] = ele
                })

                let topQuestions = []

                unique.forEach(item => {
                    topQuestions.push(...item.allQuestionsArray)
                })

                let topFiveWrongAnsweredQuestions = topQuestions.slice(0, 5)

                // console.log('top', unique)

                let contentIds = []

                topFiveWrongAnsweredQuestions.forEach(question => contentIds.push(question._id.toString()))

                let topWrongPercentage = unique && unique.length ? unique[0].percentage : 0

                this.setState({
                    wrongAnswers: unique, wrongAnswersHash, wrongAnswersOfallUsers: unique,
                    basePath: response.basePath, availabelFiltersHash: filterHash, topFiveWrongAnsweredQuestions,
                    contentIds,
                    topWrongPercentage,

                })

                if (selectedReportType === 'MOST_WRONG_REPORT') {
                    this.setState({ isPdfLoading: false })
                    this.downloadPDF(response.link, "Most_Wrong_Questions")
                } else {
                    this.getEloReport(selectedItem, selectedReportType)
                }

            }).catch(err => {
                console.log(err)
            })
    }

    downloadPDF(pdfLink, title) {
        const link = document.createElement("a");
        link.href = pdfLink
        link.target = "_blank";
        link.download = `${title}.pdf`; // name for downloaded file
        link.click();
        this.setState({ selectedReportType: "", selectedItem: '', selectedIndex: "" })
    }

    getReportList = (item, index, grpIndex) => {
        console.log(".....", item)

        if (this.props.type == 'STANDARD_CLASSWORK') {
            return (
                <div onMouseEnter={ReactTooltip.rebuild}>
                    <div className='row flex-nowrap'>
                        <div className='col-7 px-0'>
                            {/* <Link className='report-wrapper' to={
                                {pathname:`${Path.HOMEWORK_COMPLETION_REPORT}${this.props.type}/${item._id}/${item.chapter}/${item.class}/${item.createdDateTimestamp}`,  
                                state:"Hello World"}} target='_blank' onClick={() => { this.showReport('COMPLETION_REPORT', item, index) }}>
                                <img className='report-icon' src={getImageSource(ImageConstants.COMPLETION_REPORT)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Completion Report</span>
                            </Link> */}
                            <div className='report-wrapper' onClick={() => { this.showReport("COMPLETION_REPORT", item, index) }}>
                                <img className='report-icon' src={getImageSource(ImageConstants.EXAM_PAD_ICON)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Completion Report</span>
                            </div>

                            {/* <img className='report-icon' src={getImageSource(ImageConstants.COMPLETION_REPORT)} /> */}
                            {/* <span className={`${item.completed ? "blue" : ""}`} >Completion Report</span> */}

                            {/* <Link to={Path.HOMEWORK_ASSIGN} target="_blank">
                                        Completion Report      
                            </Link> */}
                        </div>
                        {
                            item.completed && item.completed.length ?
                                <div className='col-5 download-icon-wrapper cursor-pointer' onClick={() => this.downloadCompletionExcelReport("COMPLETION_REPORT", item, index)}>
                                    <img data-tip={"Export to Excel"} className='report-icon cursor-pointer' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} />
                                </div>
                                :
                                <></>
                        }


                    </div>

                    <div className='row flex-nowrap'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("HOMEWORK_EVALUATION_REPORT", item, index)}>
                                <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                                {/* <span className={`${item.completed ? "blue" : ""}`}>{`${item.type === 'STANDARD' ? 'Homework' : 'Classwork'} Evaluation Report`}</span> */}
                                <span className={`${item.completed ? "blue" : ""}`}>{`Evaluation Report`}</span>
                            </div>
                        </div>
                        {
                            item.completed && item.completed.length ?
                                <div className='col-5 download-icon-wrapper cursor-pointer' onClick={() => this.downloadEvaluationExcelReport("HOMEWORK_EVALUATION_REPORT", item, index)}>
                                    <img data-tip={"Export to Excel"} className='report-icon' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} />
                                </div>
                                :
                                <></>
                        }


                    </div>

                    <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("MOST_WRONG_REPORT", item, index)}>
                                <img className='report-icon' src={getImageSource(ImageConstants.WRONG_QUESTIONS)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Most Wrong Questions</span>
                            </div>
                        </div>

                        {
                            item.completed && item.completed.length ?
                                <div className='col-5 download-icon-wrapper d-flex align-items-center'
                                >
                                    <img className='report-icon' />

                                    {
                                        this.state.isPdfLoading && this.state.selectedIndex === index && this.state.selectedReportType === 'MOST_WRONG_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                            <img className='green-download-icon cursor-pointer ml-2'
                                                data-tip="Download Report" onClick={() => this.onClickDownloadPdf("MOST_WRONG_REPORT", item, index)}
                                                src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                    }

                                </div>
                                :
                                <></>
                        }
                    </div>

                    <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("ALL_QUESTIONS_REPORT", item, index)}>
                                <img className='report-icon' src={getImageSource(ImageConstants.ALL_QUESTIONS)} />
                                <span className={`${item.completed ? "blue" : ""}`}>All Questions</span>
                            </div>
                        </div>
                    </div>

                    {/* <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.onCLickStudentLevelReport(item)}>
                                <span className={`${item.completed ? "blue" : ""}`}>Student Level Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper'>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div> */}

                    <div className='row flex-nowrap'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("ELO_LEVEL_REPORT", item, index)}>
                                <img className='report-icon' src={getImageSource(ImageConstants.BULB_BLUE)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Learning Gap Report</span>
                            </div>
                        </div>

                        {
                            item.completed && item.completed.length ?
                                <div className='col-5 download-icon-wrapper cursor-pointer'
                                    onClick={() => this.downloadLearningGapExcelReport("ELO_LEVEL_REPORT", item, index)}>
                                    <img data-tip={"Export to Excel"} className='report-icon' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} />
                                </div>
                                :
                                <></>
                        }


                    </div>

                    <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("RECOMMANDATION_REPORT", item, index)}>
                                <img className='report-icon' src={getImageSource(ImageConstants.BULB_BLUE)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Remedial Report</span>
                            </div>
                        </div>
                        {
                            item.completed && item.completed.length ?
                                <div className='col-5 download-icon-wrapper d-flex align-items-center'
                                >
                                    <img className='report-icon' />

                                    {
                                        this.state.isPdfLoading && this.state.selectedIndex === index &&
                                            this.state.selectedReportType === 'RECOMMANDATION_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                            <img className='green-download-icon cursor-pointer ml-2'
                                                data-tip="Download Report" onClick={() => this.onClickDownloadPdf("RECOMMANDATION_REPORT", item, index)}
                                                src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                    }


                                </div>
                                :
                                <></>
                        }
                    </div>

                    <div className='row flex-nowrap'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("CLASS_PERFORMANCE_REPORT", item, index)}>
                                <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                                {/* <span className={`${item.completed ? "blue" : ""}`}>{`${item.type === 'STANDARD' ? 'Homework' : 'Classwork'} Evaluation Report`}</span> */}
                                <span className={`${item.completed ? "blue" : ""}`}>{`Students Performance Report`}</span>
                            </div>
                        </div>
                        {
                            item.completed && item.completed.length ?
                                <div className='col-5 download-icon-wrapper'
                                >
                                    <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} data-tip={"Export to Excel"}
                                        onClick={() => this.downloadClassPerformanceExcelReport("CLASS_PERFORMANCE_REPORT", item, index)} />

                                    {
                                        this.state.isPdfLoading && this.state.selectedIndex === index &&
                                            this.state.selectedReportType === 'CLASS_PERFORMANCE_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                            <img className='green-download-icon cursor-pointer ml-2'
                                                data-tip="Download Report" onClick={() => this.onClickDownloadPdf("CLASS_PERFORMANCE_REPORT", item, index)}
                                                src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                    }


                                </div>
                                :
                                <></>
                        }


                    </div>

                    <div className='row flex-nowrap align-items-center'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT", item, index)}>
                                <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                                <span className={`${item.completed ? "blue" : ""}`}>{`Class Performance Report`}</span>
                            </div>
                        </div>
                        {
                            item.completed && item.completed.length ?
                                <div className='col-5 download-icon-wrapper d-flex align-items-center'
                                >
                                    <img className='report-icon' />

                                    {
                                        this.state.isPdfLoading && this.state.selectedIndex === index &&
                                            this.state.selectedReportType === 'SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                            <img className='green-download-icon cursor-pointer ml-2'
                                                data-tip="Download Report" onClick={() => this.onClickDownloadPdf("SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT", item, index)}
                                                src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                    }

                                </div>
                                :
                                <></>
                        }
                    </div>

                    {/* <div className='row flex-nowrap align-items-center'>
                        <div className='col-7 px-0'>
                            <Link to={{ pathname: Path.STUDENT_LOGOUT_REPORT, state: { board: item.board, class: item.class, section: item.section, subject: item.subjectName || item.subject || 'Mathematics', chapter: (Array.isArray(item.chapters) && item.chapters.length > 0 ? (typeof item.chapters[0] === 'object' ? (item.chapters[0].title || item.chapters[0].name || '') : item.chapters[0]) : (item.chapterTitle || item.chapterName || item.chapter || item.title || '')), homeworkId: typeof item._id === 'object' ? (item._id.$oid || item._id.toString()) : (item._id || item.homeworkId || item.id || ''), autoFetch: true } }} style={{ textDecoration: 'none', color: 'inherit' }}>
                                <div className='report-wrapper'>
                                    <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                                    <span className="blue">{`Student Logout Report`}</span>
                                </div>
                            </Link>
                        </div>
                        <div className='col-5 px-0'>
                            <div className='d-flex align-items-center'>
                                <img 
                                    data-tip={"Export to Excel"} 
                                    className='report-icon cursor-pointer' 
                                    src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} 
                                    onClick={() => this.onClickDownloadLogoutReport(item)}
                                />
                            </div>
                        </div>
                    </div> */}

                    {/base\s*line/i.test(item?.selectedQuestionSetTitle || item?.questionSetTitle || item?.setName || '') && (
                    <div className='row flex-nowrap align-items-center'>
                        <div className='col-7' onClick={() => this.onClickShowExamPrepReport(item)} style={{ cursor: 'pointer' }}>
                            <div className='report-wrapper'>
                                <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                                <span className="blue">{`Exam Prep Report`}</span>
                            </div>
                        </div>
                        <div className='col-5 px-0'>
                            <div className='d-flex align-items-center'>
                                <img
                                    data-tip={"Export to Excel"}
                                    className='report-icon cursor-pointer'
                                    src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)}
                                    onClick={() => this.onClickDownloadExamPrepReport(item)}
                                />
                            </div>
                        </div>
                    </div>
                    )}




                    {/* {
                        item.type === "MCQ" ?
                            <div className='row flex-nowrap'>
                                <div className='col-8 px-0'>
                                    <div className='report-wrapper' onClick={() => this.showReport("STANDARD_COMPETENCY_REPORT", item, index)}>
                                        <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                                        <span className={`${item.completed ? "blue" : ""}`}>{`Student Performance Report`}</span>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className='row flex-nowrap'>
                                <div className='col-8 px-0'>
                                    <div className='report-wrapper' onClick={() => this.showReport("STANDARD_COMPETENCY_REPORT", item, index)}>
                                        <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                                        <span className={`${item.completed ? "blue" : ""}`}>{`Student Performance Report`}</span>
                                    </div>
                                </div>
                            </div>
                    } */}




                    {/* <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showDownloadReport(item, "overall")}>
                                <span className={`${item.completed ? "blue" : ""}`}>Download Overall Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper cursor-pointer'>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div> */}
                </div>
            )
        }

        if (this.props.type == 'ADAPTIVE_CLASSWORK') {
            return (
                <div>
                    <div className='row flex-nowrap'>
                        <div className='col-8 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("COMPLETION_REPORT", item, index, grpIndex)}>
                                <img className='report-icon' src={getImageSource(ImageConstants.EXAM_PAD_ICON)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Completion Report</span>
                            </div>
                        </div>

                        {
                            item.completed && item.completed.length ?
                                <div className='col-5 download-icon-wrapper cursor-pointer' data-tip={"Export to Excel"} onClick={() => this.downloadCompletionExcelReport("COMPLETION_REPORT", item, index, grpIndex)}>
                                    <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} />
                                </div>
                                :
                                <></>
                        }
                    </div>

                    <div className='row flex-nowrap'>
                        <div className='col-8 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("HOMEWORK_EVALUATION_REPORT", item, index, grpIndex)}>
                                <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Evaluation Report</span>
                            </div>
                        </div>

                        {
                            item.completed && item.completed.length ?
                                <div className='col-5 download-icon-wrapper cursor-pointer' data-tip={"Export to Excel"} onClick={() => this.downloadEvaluationExcelReport("HOMEWORK_EVALUATION_REPORT", item, index, grpIndex)}>
                                    <img className='report-icon' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} />
                                </div>
                                :
                                <></>
                        }
                    </div>

                    <div className='row'>
                        <div className='col-8 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("MOST_WRONG_REPORT", item, index, grpIndex)} >
                                <img className='report-icon' src={getImageSource(ImageConstants.WRONG_QUESTIONS)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Most Wrong Questions</span>
                            </div>
                        </div>

                        {/* <div className='col-5 download-icon-wrapper' onClick={() => this.showDownloadReport(item, "MOST_WRONG_REPORT")}>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div> */}
                    </div>
                    <div className='row'>
                        <div className='col-8 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("ALL_QUESTIONS_REPORT", item, index, grpIndex)}>
                                <img className='report-icon' src={getImageSource(ImageConstants.ALL_QUESTIONS)} />
                                <span className={`${item.completed ? "blue" : ""}`}>All Questions</span>
                            </div>
                        </div>
                    </div>
                    <div className='row flex-nowrap'>
                        <div className='col-8 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport("ELO_LEVEL_REPORT", item, index, grpIndex)}>
                                <img className='report-icon' src={getImageSource(ImageConstants.BULB_BLUE)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Learning Gap Report</span>
                            </div>
                        </div>

                        {
                            item.completed && item.completed.length ?
                                <div className='col-5 download-icon-wrapper cursor-pointer' data-tip={"Export to Excel"}
                                    onClick={() => this.downloadLearningGapExcelReport("ELO_LEVEL_REPORT", item, index, grpIndex)}>
                                    <img className='report-icon' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} />
                                </div>
                                :
                                <></>
                        }
                    </div>


                    {/* <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showDownloadReport(item, "overall")}>
                                <span className={`${item.completed ? "blue" : ""}`}>Download Overall Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper'>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div> */}
                    {/* <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport('LEVEL_PROGRESSION_REPORT', item)}>
                                <span className={`${item.completed ? "blue" : ""}`}>Level Progression Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper'>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div> */}

                    {/* <div className='row'>
                        <div className='col-5'>
                            <div className='report-wrapper' onClick={() => this.showReport('LEVEL_IMPROVEMENT_REPORT')}>
                                <img className='report-icon' src={getImageSource(ImageConstants.LEVEL_IMPROVEMENT_REPORT)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Level Improvement Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper'>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div> */}
                </div>
            )
        }
    }

    showDownloadReport = (item, reportType) => {
        this.setState({
            isDownloading: true,
            selectedItem: item
        }, _ => {
            this.downloadReport(item, reportType)
        })
    }

    downloadReport(item, reportType) {
        const payload = {
            type: this.props.type,
            reportType
        }
        if (item) {
            payload.id = item._id
        }

        HomeworkApi.downloadHomeworkReport(payload)
            .then(response => {
                if (response.url) {
                    window.open(response.url)
                }
                this.setState({ isDownloading: false })
            }).catch(err => {
                this.setState({ isDownloading: false })
                this.showToaster('info', `${err?.response?.data?.message || "Something went wrong"} `)
            })
    }

    getReminderAction() {
        if (this.props.type == "ADAPTIVE") {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_REMINDER]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_REMINDER]
        }
    }

    getArchivedAction() {
        if (this.props.type == "ADAPTIVE") {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_ARCHIVE]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_ARCHIVE]
        }
    }

    getActivateHomeworkAction() {
        if (this.props.type == "ADAPTIVE") {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_ACTIVE]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_ACTIVE]
        }
    }


    onClickReminderModal(item) {
        let concept = item.concepts?.map(i => i.title) || []
        let [d, m, y] = item.dueDate.split("/")

        if (m.length == 1) {
            m = `0${m}`
        }
        if (d.length == 1) {
            d = `0${d}`
        }
        let dateString = `${y}-${m}-${d}`
        let date = moment(dateString).format("Do MMM")
        let message = `${item.type === 'STANDARD' || item.type === 'ADAPTIVE' ? 'Homework' : 'Classwork'} assigned to you from chapter ${item?.chapter || ""}  & concepts ${concept.join(",")} is still pending. Please complete it soon before due date i.e ${date}.`
        let notificationCount = item.notificationCount
        let notificationDate = item.lastNotificationSentDate
        this.setState({
            reminderHomeworkId: item._id,
            reminderMessage: message,
            showReminderModal: true,
            notificationCount,
            notificationDate,
            notCompleted: item?.notCompleted?.length
        })
    }

    getEloDetails(item) {
        console.log(item)
        let concepts = [], elos = []
        if (item.chapters && item.chapters.length) {
            item.chapters.forEach(chapter => {
                chapter.concept.forEach(element => {
                    concepts.push(element.key)
                    element.elos.forEach(item => {
                        elos.push(item.id)
                    })

                });
            })

        } else {
            item.concepts.forEach(element => {
                concepts.push(element.key)
                element.elos.forEach(item => {
                    elos.push(item.id)
                })

            });
        }

        let payload = {
            class: item?.class,
            board: item?.board,
            section: item?.section,
            chapter: item?.chapter,
            concepts: concepts.join(","),
            elos: elos.join(","),
            homeworkType: item.type
        }



        if (!payload.class || !payload.board || !payload.chapter) return

        if (payload.class === 'Class 10' && item.moreThanOneAssessment) {

            payload.contentsHash = Object.keys(item.contentsHash)
        }

        if (payload.class === 'Class 10') {
            payload.assessmentQuestionType = item.assessmentQuestionType
            payload.questionCategory = item.questionCategory ? item.questionCategory : 'M1'
        }

        if (item.assessmentQuestionType === 'SELECTED_ASSESSMENT_QUESTIONS') {
            payload.assessmentQuestionType = item.assessmentQuestionType
            payload.contentsHash = Object.keys(item.contentsHash)
        } else {
            payload.contentsHash = Object.keys(item.contentsHash)
        }

        if (item.category) {
            payload.isAdaptive = true
        }


        HomeworkApi.getHomeworkEloDetailsForClickerPractice(payload)
            .then(response => {
                this.setState({
                    questionCount: response.questionCount,
                    contents: response.content,
                    // approximateTime: response.questionCount, //ask by ravi
                    approximateTime: response.approximateTime, //ask by ravi
                    questionLoading: false,
                    showQuestionList: true,
                })
            }).catch(err => {
                console.log(err)
            })
    }

    onClickQuestionList(item, index, groupIndex) {
        if (item.type === this.caseStudy) {
            this.setState({
                selectedQuestionList: item,
                contents: [],
                questionLoadingIndex: index,
                questionLoading: true,
                showQuestionList: true,
                selectedItem: item
            })
        } else {
            this.setState({
                selectedQuestionList: item,
                contents: [],
                questionLoadingIndex: index,
                questionLoadingGroupIndex: groupIndex,
                questionLoading: true,
                selectedItem: item
            })
            this.getEloDetails(item)
        }
    }

    hideQuestionList = () => {
        this.setState({ showQuestionList: false, questionLoading: false })
    }

    onOkDeleteModal = () => {
        this.setState({ showDeletionModal: false })
    }

    onCloseDeleteModal = () => {
        this.setState({ showDeletionModal: false })
    }


    showQuestionList = () => {

        if (this.state.selectedItem.type === this.caseStudy) {
            return (
                <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideQuestionList} size={'lg'}>
                    <ModalBody >
                        <TestQuestionList selectedItem={this.state.selectedItem} delegate={this} close={this.hideQuestionList} />
                    </ModalBody>
                </Modal>
            )
        }

        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideQuestionList} size={'lg'}>
                <ModalBody >
                    <QuestionList back={this.hideQuestionList}
                        contents={this.state.contents}
                        questionCount={this.state.questionCount}
                        approximateTime={this.state.approximateTime} />
                </ModalBody>
            </Modal>
        )
    }


    getActions = (item, index, groupIndex) => {

        if (!groupIndex) groupIndex = 0

        return (
            <div className="text-right" onMouseEnter={ReactTooltip.rebuild}>
                {
                    this.getArchivedAction()
                        ? <>
                            <img alt="" className='action-icon cursor-pointer' id={`rchived-tooltip-${index}_${groupIndex}`} src={getImageSource(ImageConstants.ARCHIVE)} onClick={() => this.setState({ showArchiveModal: true, selectedHomework: item })} />
                            <Tooltip className={`${this.state.tooltipOpenIndex === index && this.state.tooltipGroupIndex === groupIndex ? "show" : "hide-tooltip"}`} placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={`rchived-tooltip-${index}_${groupIndex}`} toggle={() => { this.setState({ tooltipOpen: !this.state.tooltipOpen, tooltipOpenIndex: index, tooltipGroupIndex: groupIndex }) }}>
                                Archive
                            </Tooltip>
                        </>
                        : ""
                }
                <span className="pl-4">
                    {
                        this.getReminderAction() ?
                            <>
                                <img alt="" className='action-icon cursor-pointer' id={`reminder-tooltip-${index}_${groupIndex}`} src={getImageSource(ImageConstants.REMAINDER)} onClick={() => this.onClickReminderModal(item)} />
                                <Tooltip className={`${this.state.reminderToolTipIndex === index && this.state.reminderToolTipGroupIndex === groupIndex ? "show" : "hide-tooltip"}`} placement="top" isOpen={this.state.reminderTooltipOpen} autohide={false} target={`reminder-tooltip-${index}_${groupIndex}`} toggle={() => { this.setState({ reminderTooltipOpen: !this.state.reminderTooltipOpen, reminderToolTipIndex: index, reminderToolTipGroupIndex: groupIndex }) }}>
                                    Reminder
                                </Tooltip>
                            </>
                            : ""
                    }
                </span>
                <span className="pl-4">
                    {
                        this.getReminderAction() && !item.completed.length ?
                            <>
                                <img alt="" data-tip={'Delete Assignment'} className='action-icon cursor-pointer' src={getImageSource(ImageConstants.DELETE)} onClick={() => this.setState({ showDeletionModal: true, selectedHomework: item })} />
                                {/* <Tooltip className={`${this.state.reminderToolTipIndex === index && this.state.reminderToolTipGroupIndex === groupIndex ? "show" : "hide-tooltip"}`} placement="top" isOpen={this.state.reminderTooltipOpen} autohide={false} target={`reminder-tooltip-${index}_${groupIndex}`} toggle={() => { this.setState({ reminderTooltipOpen: !this.state.reminderTooltipOpen, reminderToolTipIndex: index, reminderToolTipGroupIndex: groupIndex }) }}>
                                    Delete
                                </Tooltip> */}
                            </>
                            : ""
                    }
                </span>
            </div>
        )

    }

    getActivateHomework = (item) => {

        return (
            <div className='text-right' >

                {
                    this.getActivateHomeworkAction() ?
                        <span className='cursor-pointer' onClick={() => this.setState({ showActiveConfirmationModal: true, selectedHomework: item })}>Mark As Active</span>
                        : <></>
                }


            </div>
        )

    }


    categoryColor(category) {
        if (category === "ADVANCED") return "bg-lite-blue"
        if (category === "PROFICIENT") return "bg-orange"

        return "bg-purble"
    }

    getCategoryText(category) {

        if (category === "ADVANCED") return "Advanced"
        if (category === "PROFICIENT") return "Proficient"

        return "Novice"
    }

    onClickUserList(index, groupIndex) {
        this.setState({ userListIndex: index, userListGroupIndex: groupIndex })
    }

    onHideUserList() {
        this.setState({ userList: [], userListIndex: "", userListGroupIndex: "" })

    }

    renderUserList(item) {
        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.onHideUserList()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div>

                {
                    item?.users?.length ? item.users.map((user, index) =>
                        <div className='px-4 py-2 row align-items-center'>
                            <div className="profile-avatar text-center mr-2 d-inline-block">
                                <div className="row justify-content-center">
                                    {user.image ? <img className="" alt="img" src={`${item.basePath}${user.image}`} />
                                        :
                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                </div>
                            </div>
                            <div className='student-name ml-2'>
                                {user.name}
                            </div>
                        </div>

                    )
                        :
                        <div className="text-center pt-4">No Records Found</div>
                }
            </div>
        )
    }

    getTestCard = (item, index) => {

        // console.log(item)

        return (
            <div className='homework-card mt-1'>
                <div className='row m-0'>
                    <div className={`col border-bottom ${this.state.activeTabIndex === 0 || this.state.activeTabIndex === 3 ? 'border-right' : ""}`} style={{ textAlign: `${this.state.activeTabIndex === 0 ? "" : 'start'}` }}>
                        <div className='header-label'>Created: <strong>{item.createdDate}</strong></div>
                    </div>

                    {
                        item.type != 'CASE_STUDY' ?
                            <div className='col border-bottom' >
                                <div className='header-label'>Due: <strong className="pr-2">{item.dueDate}</strong>
                                    {
                                        this.state.activeTabIndex === 0 ?
                                            <DateRangePicker onApply={(event, picker) => this.handleDateEvent(event, picker, item, index)}
                                                initialSettings={{ singleDatePicker: true, minDate: this.startDate ? this.startDate : new Date() }}
                                            >
                                                <img className="edit-icon" src={getImageSource(ImageConstants.EDIT)} />
                                            </DateRangePicker>
                                            :
                                            <></>
                                    }
                                </div>
                            </div>
                            :
                            <div className='col border-bottom' >
                                <div className='header-label'><strong className="pr-2">Case Study Based Questions</strong>
                                </div>
                            </div>
                    }



                </div>

                <div className='p-3'>
                    <div className='row '>
                        <div className='col'>
                            <div className='body-title'>Chapters</div>
                            {item.chapters?.map(chapter => (
                                <div className='body-sub-title pt-2'><strong>{chapter.title}</strong></div>
                            ))}
                        </div>
                        <div className="col text-right">
                            <span>Qs: <strong className="mr-2">{item.questions || 0}</strong></span>
                            <span>Time: {item.time ? <strong className="">{item.time} mins</strong> : "-"}</span>
                        </div>
                    </div>

                    <div className='pt-3 row more-color'>
                        <div className='col my-auto'>
                            {item?.type == "DIAGNOSTIC" ? <span className="type-tag ">Chapter Readiness Test</span> : ""}
                        </div>
                        {
                            item.type != 'CASE_STUDY' ?
                                <div className='col text-right'>
                                    {
                                        item?.status != "ARCHIVED" ? this.getActions(item, index) : this.getActivateHomework(item)
                                    }
                                </div>
                                :
                                <></>
                        }

                    </div>
                </div>

            </div>
        )

    }

    renderTableRow(item, index) {

        if (Array.isArray(item)) {

            return item.map((element, groupIndex) => (
                <tr id={item._id} key={element._id}
                    onMouseEnter={ReactTooltip.rebuild}
                    className={`${groupIndex === item.length - 1 ? "tr-divider" : "tr-divider-lite"} ${index === this.state.selectedItemIndex && groupIndex === this.state.selectedItemGroupIndex ? "tr-bg-color" : ''} `} >
                    <td>{this.getHomeworkCard(element, index, groupIndex)}</td>
                    <td>
                        <span className="px-4">{element.class} {element.section}</span>
                        {element?.category ? <div className="mt-1"><span className={`category-badge ${this.categoryColor(element?.category)}`}>{this.getCategoryText(element?.category)}</span></div> : ""}
                        <div className="mt-4 pl-4" >
                            <img alt="" className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.USER1)} data-tip={'Students List'} onClick={() => this.onClickUserList(index, groupIndex)} />
                            <div className="pl-4">
                                {
                                    this.state.userListIndex === index && this.state.userListGroupIndex == groupIndex ? this.renderUserList(element) : ""
                                }
                            </div>
                        </div>

                        <div className="mt-4 pl-4" >
                            {
                                this.state.questionLoading && this.state.questionLoadingIndex === index && this.state.questionLoadingGroupIndex === groupIndex ?
                                    <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                    :
                                    <img alt="" className="icon-30 cursor-pointer"
                                        data-tip={'Questions List'}
                                        src={getImageSource(ImageConstants.BULLET_LIST)} onClick={() => this.onClickQuestionList(element, index, groupIndex)} />}
                        </div>
                    </td>
                    <td>{this.renderStatus(element, index, groupIndex)}</td>
                    {
                        element.completed && element.completed.length ?
                            <td>{this.getReportList(element, index, groupIndex)}</td>
                            :
                            <td>No Reports Available. Please Complete this Practice to See the Reports</td>

                    }



                    {/* <td>{this.renderNotificationIcons(element)}</td> */}
                </tr>
            ))
        }

        if (item.type === this.caseStudy) {
            return (
                <tr onMouseEnter={ReactTooltip.rebuild} id={item._id} key={item._id} className={`tr-divider ${index === this.state.selectedItemIndex ? "tr-bg-color" : ""}`}>
                    <td>{this.getTestCard(item, index)}</td>
                    <td>
                        <span>{item.class} {item.section}</span>
                        <div className='mt-4 pl-1'>
                            <img alt="" className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.USER1)} onClick={() => this.onClickUserList(index)} />
                            <div className="pl-4">
                                {
                                    this.state.userListIndex === index ? this.renderUserList(item) : ""
                                }
                            </div>
                        </div>

                        <div className="mt-4 pl-1" >
                            {
                                this.state.questionLoading && this.state.questionLoadingIndex === index ?
                                    <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                    :
                                    <img alt="" className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.BULLET_LIST)} onClick={() => this.onClickQuestionList(item, index)} />}
                        </div>



                    </td>
                    <td>{this.renderStatus(item, index)}</td>

                    <td>{this.getReportList(item, index)}</td>
                    {/* <td>{this.renderNotificationIcons(item)}</td> */}
                </tr>
            )
        }

        return (

            <tr id={item._id} key={item._id}
                onMouseEnter={ReactTooltip.rebuild}
                className={`tr-divider ${index === this.state.selectedItemIndex ? "tr-bg-color" : ''}`}>
                <td>{this.getHomeworkCard(item, index)}</td>
                <td>
                    <span className="px-4">{item.class} {item.section}</span>
                    {
                        this.state.activeTabIndex != 3 ?
                            <div className="mt-4 pl-4" >
                                <img alt="" className="icon-30 cursor-pointer"
                                    data-tip={'Students List'}
                                    src={getImageSource(ImageConstants.USER1)} onClick={() => this.onClickUserList(index, 0)} />
                                <div className="mt-2 pl-4">
                                    {
                                        this.state.userListIndex === index && this.state.userListGroupIndex === 0 ? this.renderUserList(item) : ""
                                    }
                                </div>
                            </div>
                            :
                            <></>
                    }

                    <div className="mt-4 pl-4" >
                        {
                            this.state.questionLoading && this.state.questionLoadingIndex === index && this.state.questionLoadingGroupIndex === 0 ?
                                <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                :
                                <img alt="" className="icon-30 cursor-pointer"
                                    data-tip={'Questions List'}
                                    src={getImageSource(ImageConstants.BULLET_LIST)} onClick={() => this.onClickQuestionList(item, index, 0)} />
                        }
                    </div>
                </td>
                {
                    this.state.activeTabIndex != 3 ?
                        <>
                            <td>{this.renderStatus(item, index)}</td>
                            {
                                item.completed && item.completed.length ?
                                    <td>{this.getReportList(item, index)}</td>
                                    :
                                    <td>No Reports Available. Please Complete this Practice to See the Reports</td>

                            }

                        </>
                        :
                        <>
                            <td>
                            </td>
                            <td>
                                <button className='cw-btn-md d-inline-block cw-btn-primary' onClick={() => this.onClickNewHomeWork(item, index, true)}>
                                    Assign Schoolwork
                                </button>
                            </td>
                        </>
                }
                {/* <td>{this.renderNotificationIcons(item)}</td> */}
            </tr>
        )
    }

    renderList = () => {
        return (
            <div className='tabs-wrapper'>
                <div className='tabs ml-5'>
                    {this.getTabs()}
                </div>
                <div id="table-scoll" className="table-responsive mt-8">
                    <table className="table cw-table mb-0 align-items-center custom-homework-table">
                        <thead>
                            <tr className="tr-divider-thin">
                                <th className='th-left-radius homework-text'>School Assignment</th>
                                <th><span className="px-4">Class</span></th>
                                {
                                    this.state.activeTabIndex != 3 ?
                                        <>
                                            <th>Status</th>
                                            <th className='th-right-radius'>Reports</th>
                                        </>
                                        :
                                        <>
                                            <th></th>
                                            <th className='th-right-radius'></th>
                                        </>
                                }

                                {/* <th className="th-right-radius"></th> */}
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {
                                this.state.homeworkList && this.state.homeworkList.length ? this.state.homeworkList?.map((item, index) => (
                                    this.renderTableRow(item, index)
                                ))
                                    : <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Record's found</td></tr>
                            }
                        </tbody>
                    </table>
                </div >
            </div>
        )
    }

    hideTestResultsReport() {
        this.hideReport()
    }

    renderReport = () => {

        if (this.state.selectedHomework.type === this.caseStudy) {
            switch (this.state.selectedReportType) {

                case "HOMEWORK_EVALUATION_REPORT":
                    return <TestHomeworkEvalutionReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} onClickStudent={this.onClickStudent} />

                case "COMPLETION_REPORT":
                    return <CompletionReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} />

                case "LEVEL_PROGRESSION_REPORT":
                    return <HomeworkProgressionReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} />

                case "STUDENT_DETAIL_REPORT":
                    return <StudentDetailReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} student={this.state.selectedStudent} onClickBack={this.onClickStudentDetailBack} />

                case "ELO_LEVEL_REPORT":
                    return <TestEloReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} student={this.state.selectedStudent} />

                case "MOST_WRONG_REPORT":
                    return <WronglyAnswered show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} selectedItem={this.state.selectedHomework} />

                case "ALL_QUESTIONS_REPORT":
                    return <AllQuestions delegate={this} close={this.hideReport} selectedItem={this.state.selectedHomework} />

                case "RECOMMANDATION_REPORT":
                    return <TestRecommandationReport show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} selectedItem={this.state.selectedHomework} />

                case "STANDARD_COMPETENCY_REPORT":
                    return <StudentPerformanceReport type={this.state.selectedHomework.type} delegate={this} close={this.hideReport} selectedItem={this.state.selectedHomework} />

                case "CLASS_PERFORMANCE_REPORT":
                    return <ClassPerformanceReport
                        delegate={this}
                        close={this.hideReport}
                        selectedItem={this.state.selectedHomework}
                    />

                case "SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT":
                    return <SchoolworkOverallClassPerformanceReport
                        delegate={this}
                        close={this.hideReport}
                        selectedItem={this.state.selectedHomework}
                    />


                default:
                    break
            }
        }

        switch (this.state.selectedReportType) {

            case "HOMEWORK_EVALUATION_REPORT":
                return <HomeworkEvalutionReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} onClickStudent={this.onClickStudent} />

            case "COMPLETION_REPORT":
                return <CompletionReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} />

            case "LEVEL_PROGRESSION_REPORT":
                return <HomeworkProgressionReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} />

            case "STUDENT_DETAIL_REPORT":
                return <StudentDetailReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} student={this.state.selectedStudent} onClickBack={this.onClickStudentDetailBack} />

            case "ELO_LEVEL_REPORT":
                return <EloReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} student={this.state.selectedStudent} />

            case "MOST_WRONG_REPORT":
                return <WronglyAnswered show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} selectedItem={this.state.selectedHomework} />

            case "ALL_QUESTIONS_REPORT":
                return <AllQuestions type={this.props.type} delegate={this} close={this.hideReport} selectedItem={this.state.selectedHomework} />

            case "RECOMMANDATION_REPORT":
                return <RecommandationReport show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} selectedItem={this.state.selectedHomework} />

            case "STANDARD_COMPETENCY_REPORT":
                return <ChapterEloAssessmentReport
                    delegate={this}
                    close={this.hideReport}
                    selectedItem={this.state.selectedHomework}
                    homeworkId={this.state.selectedHomework._id}
                    reportType={this.state.selectedHomework.type}
                />

            case "CLASS_PERFORMANCE_REPORT":
                return <ClassPerformanceReport
                    delegate={this}
                    close={this.hideReport}
                    selectedItem={this.state.selectedHomework}
                />

            case "SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT":
                return <SchoolworkOverallClassPerformanceReport
                    delegate={this}
                    close={this.hideReport}
                    selectedItem={this.state.selectedHomework}
                />

            default:
                break
        }
    }

    onClickDownloadLogoutReport = (item) => {
        let payload = {
            board: item.board,
            class: item.class,
            section: item.section,
            homeworkId: typeof item._id === 'object' ? (item._id.$oid || item._id.toString()) : (item._id || item.homeworkId || item.id || '')
        };
        SchoolApi.getStudentLogoutReport(payload)
            .then(res => {
                const blob = new Blob([res], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'student-logout-report.csv';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }).catch(err => {
                console.log(err);
                alert("Error downloading report.");
            });
    }

    onClickDownloadExamPrepReport = (item) => {
        let payload = {
            board: item.board,
            class: item.class,
            section: item.section,
            assessmentId: typeof item._id === 'object'
                ? (item._id.$oid || item._id.toString())
                : (item._id || item.schoolAssessmentId || item.homeworkId || item.id || ''),
            format: 'excel'
        };
        SchoolApi.getExamPrepReport(payload)
            .then(res => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'exam-prep-report.xlsx';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }).catch(err => {
                console.log(err);
                alert("Error downloading report.");
            });
    }

    downloadClassPerformanceExcelReport = (type, item, index, grpIndex) => {
        // this.setState({ selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })
        console.log(item)

        let payload = {
            homeworkId: item._id,
            classText: item.class,
            board: item.board,
            type: item.type,
            sectionId: item.sectionId,
            section: item.section,
            masterDataId: item.masterDataId,
            duration: item.approximateTime,
            chapterKey: item.chapterKey
        }

        this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getClassPerformanceReport(payload).then(res => {
            console.log(res)

            this.onClickExportClassPerformanceExcelReport(res, item)
            this.setState({ isLoading: false })

        }).catch(err => {
            console.log(err)
        })

    }


    onClickExportClassPerformanceExcelReport = async (classPerformanceData, selectedItem) => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Student Report");

        // Header
        sheet.mergeCells("A1:D1");
        sheet.getCell("A1").value = "Summary";
        sheet.getCell("A1").font = { bold: true, size: 14 };
        sheet.getCell("A1").alignment = { horizontal: "center" };
        sheet.getCell("A1").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4AB7E7" }, // Blue background
        };



        // Info section
        // sheet.addRow([]);
        sheet.addRow(["Class", `${selectedItem.class.split(' ')[1]}${selectedItem.section}`]);
        sheet.addRow(["Date", this.getDate(selectedItem.createdDateTimestamp, true)]);
        sheet.addRow(["Chapter", selectedItem.chapter]);
        sheet.addRow(["Concepts", classPerformanceData.conceptTitleList.join(',')]);

        // sheet.addRow([]);


        // sheet.mergeCells("A6:D6");
        // sheet.getCell("A6").value = "Summary";
        // sheet.getCell("A6").font = { bold: true, size: 14 };
        // sheet.getCell("A6").alignment = { horizontal: "center" };
        // sheet.getCell("A6").fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "4AB7E7" }, // Blue background
        // };

        sheet.addRow(["Total Questions", `${selectedItem.approximateQuestions}`]);
        sheet.addRow(["Total Students", classPerformanceData.summary.totalStudents]);
        sheet.addRow(["Total Attempted", classPerformanceData.summary.totalCompletedStudents]);
        sheet.addRow(["% Accuracy", classPerformanceData.summary.accuracyPercentage + '%']);
        sheet.addRow([]);


        sheet.mergeCells("A11:E11");
        sheet.getCell("A11").value = "Student Performance Details";
        sheet.getCell("A11").font = { bold: true, size: 14 };
        sheet.getCell("A11").alignment = { horizontal: "center" };
        sheet.getCell("A11").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4AB7E7" }, // Blue background
        };

        // Table header
        const headerRow = sheet.addRow(["Rank", "Name", "# Questions Attempted", "# Questions Correct", "% Score"]);
        headerRow.font = { bold: true, size: 12 };
        // headerRow.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "FFB7D6F0" } // Light blue background
        // };
        // Apply background color + borders to header row
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFB7D6F0" } // Light blue (your screenshot color)
            };
        });
        // Loop through students array and add rows
        classPerformanceData.studentDetails.forEach((item, index) => {
            if (index === classPerformanceData.studentDetails.length - 1) {
                let lastRow = sheet.addRow([item.rank, item.studentName, item.questionsAttempted, item.questionsCorrect, `${item.scorePercentage}%`]);
                lastRow.font = { bold: true };
            } else {
                sheet.addRow([item.rank, item.studentName, item.questionsAttempted, item.questionsCorrect, `${item.scorePercentage}%`]);
            }
        });

        sheet.addRow([]);

        let secondHeaderRow = sheet.addRow(["Not Attempted Students"]);
        secondHeaderRow.font = { bold: true, size: 12 };
        // secondHeaderRow.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "FFB7D6F0" } // Light blue background
        // };
        // Apply background color + borders to header row
        secondHeaderRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFB7D6F0" } // Light blue (your screenshot color)
            };
        });
        // Loop through students array and add rows
        classPerformanceData.notAttemptedStudentNameList.forEach((item, index) => {
            sheet.addRow([item]);
        });


        // Generate Excel buffer
        const buffer = await workbook.xlsx.writeBuffer();

        // Trigger download
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download =
            `student_performance_report_${selectedItem.chapter.split(' ').join('_')}_` + new Date().toISOString() + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }


    renderFilters = () => {
        return (
            <div>{this.state.selectedFilters.map((filter, index) => (

                Array.isArray(filter.value) ?
                    filter.value?.length ?

                        <div key={'filter' + index} className='mr-2 selected-filter-container mt-4'>
                            <div className='filter-type'>{filter.type}</div>
                            {filter.value.map((item, filterIndex) =>
                                <>
                                    <div className='filter-value'>{item.title}</div>
                                </>
                            )}
                        </div>
                        : ""
                    :
                    filter.value ?
                        <div key={'filter' + index} className='selected-filter-container mr-2 mt-4'>
                            <div className='filter-type'>{filter.type}</div>
                            <div className='filter-value'>{filter.value}</div>
                        </div>
                        : ""
            ))}
            </div>
        )
    }

    showEloDetail = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideMoreInfoModal} size={'lg'}>
                <ModalBody >
                    <EloDetail back={this.hideMoreInfoModal} item={this.state.selectedHomeworkMore} />
                </ModalBody>
            </Modal>
        )
    }

    onClickArchive = (item) => {
        let payload = { homeworkId: item._id, status: "ARCHIVED" }
        HomeworkApi.updateHomework(payload)
            .then(response => {

                this.setState({ showArchiveModal: false }, () => {
                    this.getHomeworkList(this.filter)
                })

            }).catch(err => {
            })
    }

    onClickDelete = (item) => {
        let payload = { homeworkId: item._id, status: "ARCHIVED" }
        HomeworkApi.updateHomework(payload)
            .then(response => {
                this.showToaster('Info', 'Deleted Successfully')
                this.setState({ showDeletionModal: false }, () => {
                    this.getHomeworkList(this.filter)
                })

            }).catch(err => {
            })
    }

    onClickActivate = (item, dueDate) => {
        let payload = {
            homeworkId: item._id, status: "ACTIVE"
        }

        if (dueDate) {
            payload.dueDate = dueDate
        }


        console.log(payload)
        HomeworkApi.updateHomework(payload)
            .then(response => {

                this.setState({ showActiveConfirmationModal: false }, () => {
                    this.getHomeworkList(this.filter)
                })

            }).catch(err => {
            })
    }

    onFilterGo = (payload) => {

        if (!payload) {
            this.filter.board = ''
            this.filter.class = ''
            this.filter.section = ''
            this.filter.chapter = ''
            this.filter.concepts = ''
            this.filter.elos = ''
            this.filter.createdDateRangeStart = ''
            this.filter.createdDateRangeEnd = ''
            this.filter.dueDateRangeStart = ''
            this.filter.dueDateRangeEnd = ''
            this.getHomeworkList({ status: this.state.tabs[this.state.activeTabIndex].value })
            this.setState({ selectedFilters: [] })
        } else {

            let filters = []

            let filter = { ...this.filter }

            if (payload.createdDateRangeStart && payload.createdDateRangeEnd) {

                if (payload.createdDateFilter) {
                    filters.push({ type: 'Created Date', value: payload.createdDateFilter })
                }

                this.filter.createdDateRangeStart = payload.createdDateRangeStart
                this.filter.createdDateRangeEnd = payload.createdDateRangeEnd
            }

            if (payload.dueDateRangeStart && payload.dueDateRangeEnd) {

                if (payload.dueDateFilter) {
                    filters.push({ type: 'Due Date', value: payload.dueDateFilter })
                }

                this.filter.dueDateRangeStart = payload.dueDateRangeStart
                this.filter.dueDateRangeEnd = payload.dueDateRangeEnd
            }

            if (payload.board) {
                filters.push({ type: 'Board', value: payload.board })
                this.filter.board = payload.board
            }

            if (payload.class) {
                filters.push({ type: 'Class', value: payload.class })
                this.filter.class = payload.class
            }

            if (payload.section) {
                if (payload.section) {
                    filters.push({ type: 'Section', value: payload.sectionObject })
                }
                this.filter.section = payload.section
            }

            if (payload.chapter) {
                if (payload.chapterObject) {
                    filters.push({ type: 'Chapter', value: payload.chapterObject.title })
                }
                this.filter.chapter = payload.chapter
            }

            if (payload.concepts) {
                if (payload.conceptsObject) {
                    filters.push({ type: 'Concepts', value: payload.conceptsObject })
                }
                this.filter.concepts = payload.concepts
            }

            if (payload.elos) {
                if (payload.eloObject) {
                    filters.push({ type: 'Learning Outcomes', value: payload.eloObject })
                }
                this.filter.elos = payload.elos
            }

            console.log(this.filter)

            this.setState({ selectedFilters: filters })

            this.getHomeworkList(this.filter)

        }


    }

    onPageSelected = (selectedPage, startIndex) => {
        let payload = {
            page: selectedPage,
        }
        this.startIndex = startIndex
        this.filter.page = selectedPage
        this.setState({ selectedPage, selectedItemIndex: null, selectedItemGroupIndex: null })
        this.getHomeworkList(this.filter)
    }

    checkCreateCondtion() {
        if (this.props.type == 'ADAPTIVE') {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_CREATE]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_CREATE]
        }
    }

    checkEditCondtion() {
        if (this.props.type == 'ADAPTIVE') {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_EDIT]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_EDIT]
        }
    }

    onClickStudent = (student) => {
        this.setState({ selectedStudent: student }, () => {
            this.showReport("STUDENT_DETAIL_REPORT", this.state.selectedHomework)
        })
    }

    onClickStudentDetailBack = () => {
        this.showReport("HOMEWORK_EVALUATION_REPORT", this.state.selectedHomework, this.state.selectedItemIndex, this.state.selectedItemGroupIndex)
    }


    showRewardToaster = (item) => {
        if (item.point) {
            this.showToaster('info', `🎁 YAY! You just earned ${item.point} reward points for assigning the ${item.type === 'STANDARD' ? 'Homework' : 'Classwork'} ${item?.totalUsers || 0} students from ${item.class}${item.section ? " " + item.section : ""}`)
        }
    }

    render() {
        if (this.state.showNewHomework && (this.state.boardsDropdownItems?.length !== 0 && this.state.classDropdownItems?.length !== 0)) {
            return <NewHomework type={this.props.type}
                delegate={this}
                isFromDraft={this.state.isDraft}
                selectedHomework={this.state.selectedHomework}
                moreThanOneBoard={this.state.boardsDropdownItems?.length > 1 ? true : false} />
        }

        if (this.state.showNewHomework && (this.state.boardsDropdownItems?.length == 0 || this.state.classDropdownItems?.length == 0)) {
            return <Modal className="cw-custom-modal-center modal-md" isOpen={true} toggle={this.hideNewHomework} size={''}>
                <ModalBody >
                    <div className='d-flex flex-column'>
                        <div className='margin-left'>CLASS & SECTION NOT ASSIGNED</div>
                        <div className='sub-text'>Please request the admin to assign a Class & Section to
                            your profile in order to create a Homework</div>
                    </div>
                </ModalBody>
                <ModalFooter className='justify-content-center'>
                    <Button color="primary" onClick={this.hideNewHomework}>GOT IT</Button>{' '}
                    {/* <Button color="secondary" onClick={this.toggle}>Cancel</Button> */}
                </ModalFooter>
            </Modal>
        }


        if (this.state.showReport) {
            return this.renderReport()
        }

        if (this.state.showExamPrepReport) {
            return <ExamPrepReportInline selectedItem={this.state.selectedItem} close={this.hideExamPrepReport} />
        }


        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}

                <div className='homework-list'>

                    <div>
                        {this.state.showBackButton ? <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={this.onClickBack} /> : ''}
                        {
                            this.checkCreateCondtion() ?
                                <button className='float-right cw-btn-md d-inline-block cw-btn-primary' onClick={() => this.onClickNewHomeWork()}>
                                    New Schoolwork
                                </button> : ""
                        }
                    </div>
                    <div className='screen-title mt-3'>{this.props.type === "ADAPTIVE_CLASSWORK" ? "Personalised " : "Standard "}Schoolwork List</div>
                    <div className='mt-5'>
                        <Filter delegate={this} />

                        <img className='seperator' src={getImageSource(ImageConstants.FILTER_SEPERATOR)} />
                    </div>
                    {this.renderFilters()}

                    {this.renderList()}

                    <div className='card-footer'>
                        {
                            this.state.meta.totalPages ?
                                <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta.totalPages} onPageSelected={this.onPageSelected.bind(this)} /> : ''
                        }
                    </div>
                    {/* {this.state.showWrongAnswersReport && <WronglyAnswered show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} selectedItem={this.state.selectedHomework} />} */}
                    {this.state.showStudentLevelReport && <StudentLevelReport show={this.state.showStudentLevelReport} delegate={this} close={this.hideStudentLevelReport} selectedItem={this.state.selectedHomework} onClickStudent={this.onClickStudent} />}
                    {this.state.showReminderModal ? this.renderReminderModal() : ""}
                    {this.state.showArchiveModal && <ArchiveModal title={`Are you sure you want to Archive this ${this.state.selectedHomework.type === 'STANDARD' || this.state.selectedHomework.type === 'ADAPTIVE' ? 'Homework' : 'Classwork'}?`} delegate={this} onOk={this.onOkArchiveModal} onClose={this.onCloseArchiveModal} selectedItem={this.state.selectedHomework} />}
                    {this.state.showDeletionModal && <AssignmentDeletionComponent title={`Are you sure you want to Delete this Assignment`} delegate={this} onOk={this.onOkDeleteModal} onClose={this.onCloseDeleteModal} selectedItem={this.state.selectedHomework} />}
                    {this.state.showActiveConfirmationModal && <ActiveHomeworkModal title={`Are you sure you want to Mark this ${this.state.selectedHomework.type === 'STANDARD' || this.state.selectedHomework.type === 'ADAPTIVE' ? 'Homework' : 'Classwork'} Active ?`} delegate={this} onOk={this.onOkActiveModal} onClose={this.onCloseActiveModal} selectedItem={this.state.selectedHomework} />}
                    {this.state.showMoreInfo ? this.showEloDetail() : ""}
                    {this.state.showNotification ? this.renderNotificationModal() : ""}
                    {this.state.showSuccess ? <SuccessComponent
                        title={`${this.state.selectedItem.type === 'STANDARD' || this.state.selectedItem.type === 'ADAPTIVE' ? 'HOMEWORK' : 'CLASSWORK'}  CREATED`}
                        subTitle={`Do You want to invite more students to take this ${this.state.selectedItem.type === 'STANDARD' || this.state.selectedItem.type === 'ADAPTIVE' ? 'Homework' : 'Classwork'}?`}
                        students={this.state?.selectedItem?.totalUsers || 0}
                        close={this.closeSuccess}
                        onOk={this.onInviteMoreStudent}
                        class={this.state?.selectedItem?.class}
                        section={this.state?.selectedItem?.section ? Object.values(this.state?.selectedItem?.section).join(',') : ''}
                    /> : ""}
                    {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
                    {
                        this.state.showQuestionList ? this.showQuestionList() : ""
                    }
                    {this.state.isDownloading && (
                        <Modal className="cw-custom-modal" isOpen={this.state.isDownloading} size={'md'}>
                            <ModalBody >
                                <div className="add-admin">
                                    <div className="header-text text-center">
                                        <span>{`Downloading Report...`}</span>
                                    </div>
                                    <div className='row px-5 py-5 margin-auto'>
                                        <img
                                            className='loader-icn'
                                            src={getImageSource(
                                                ImageConstants.PRE_LOADER_GIF
                                            )}
                                        />
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal >
                    )}
                </div >
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </>);
    }
}

export default HomeworkList;